// ============================================
// CONFIGURATION & CONSTANTS
// ============================================

const CONFIG = {
  imageSize: 200,
  subscriptionDiscount: 15,
  // IMPORTANT: Update these with your actual Recharge selling plan IDs
  // These IDs should be the same for all products in your store
  sellingPlans: {
    30: "26460225754", // Every 1 month
    60: "26460291290", // Every 2 months
    120: "26460324058", // Every 4 months
  },
  defaultFrequency: "30", // Default to 1 month (15% OFF)
  deliveryFrequencies: [
    { value: "30", label: "1 month (15% OFF)" },
    { value: "60", label: "2 months (10% OFF)" },
    { value: "120", label: "3 months (5% OFF)" },
  ],
  productSellingPlans: {
    "tbybtest-vb-u": {
      tbyb: "26465861850", // TBYB
      // 30: "26484179162", // Every 1 month
      // 60: "26484146394", // Every 2 months
      // 120: "26484113626", // Every 4 months
    },
    "universal-flare-care-essential-oil-free-recharge": {
      30: "26460225754", // Every 1 month
      60: "26460291290", // Every 2 months
      120: "26460324058", // Every 4 months
    },
    "thyme-tea-tree-flare-care": {
      30: "26722566362", // Every 1 month
      60: "26722631898", // Every 2 months
      120: "26722599130", // Every 4 months
    },
    "universal-flare-care": {
      30: "26503676122", // Every 1 month
      60: "26503610586", // Every 2 months
      120: "26503643354", // Every 4 months
    },
    "comfrey-arnica-relief": {
      30: "26722664666", // Every 1 month
      60: "26722697434", // Every 2 months
      120: "26722730202", // Every 4 months
    },
    "universal-flare-care-essential-oil-free": {
      30: "26723123418", // Every 1 month
      60: "26723188954", // Every 2 months
      120: "26723156186", // Every 4 months
    },
  },
  debug: false, // Set to false to disable debug logs

  // Subscription Eligibility Configuration
  // Define which products are eligible for subscriptions
  subscriptionEligibility: {
    // Set to true to make ALL products subscription-eligible by default
    // Set to false to only allow products in the allowList
    defaultEligible: false,

    // Products to EXCLUDE from subscriptions (by product title keywords)
    excludeByTitle: [
      "order protection",
      "gift card",
      "sample",
      "free item",
      "gift",
      "Pure Organic Witch Hazel Spray | 8oz",
      "Flare Care Duo | 4oz",
      "Comfort Flare Care Set",
      "The Ultimate Flare Care Trio | 2oz",
    ],

    // Products to EXCLUDE by handle
    excludeByHandle: [
      // Add product handles here, e.g., "gift-card", "sample-pack"
      "universal-flare-care-essential-oil-free-tbyb-testing",
    ],

    // If defaultEligible is false, only products in this list will be eligible
    // You can use product handles or title keywords
    allowList: [
      "43683537289434", // Green
      "43684699701466", // Purple
      "43684760256730", // Pink
      "44327996588250", // Yellow
      "48611810410714", // UFC 4oz + 1oz
      "48611799498970", // TTFC 4oz + 1oz
      "48611816145114", // UFC-EOF 4oz + 1oz
    ],
    // TBYB Selling Plan IDS to look for
  },
  tbybSellingPlanIds: ["26465861850"],
  tbybHandle: "tbyb",

  // TBYB Product Variant IDs
  // These are the two variants on the TBYB product listing
  tbybVariants: {
    otp: "47350302605530", // OTP variant ID (connects to TBYB selling plan)
    subscription: "47350302638298", // Subscription variant ID (connects to 60-day selling plan)
    subscriptionSwapItem: "47350244901082",
    subscriptionSwapItemPlanId: "26528186586",
  },

  // Gift Nudge Configuration
  fourOzSkus: ["TTFC-4OZ", "UFC-4OZ", "CAR-4OZ", "UFC-EOF-4OZ"], // Add specific SKUs if needed, e.g. ["PORR-4OZ-CHERRY", "PORR-4OZ-MINT"]
  giftProduct: {
    title: "FREE GIFT",
    image: "", // Will be populated dynamically if available
    price: "$0.00",
    tags: ["Free Gift", "Limited Time"],
  },
};

// 1oz gift promo ("buy two 4oz → FREE GIFT") disabled 2026-07 together with the
// Gift Trigger Flow workflows — see GIFT_LOGIC_DOC.md and _backup_gift_logic_2026-07/.
// Set to true (and uncomment the giftNudgeCartCtn block in snippets/cartDrawer.liquid)
// to bring the cart nudge back.
const GIFT_NUDGE_ENABLED = false;

let tbybSubscription = false;

// Helper to get selling plan ID by frequency
function getSellingPlanId(frequency) {
  const planId = CONFIG.sellingPlans[frequency];
  if (!planId) {
    log(`Warning: No selling plan ID found for frequency ${frequency}`);
  }
  return planId;
}

// Get default selling plan ID (2 months)
function getDefaultSellingPlanId() {
  return getSellingPlanId(CONFIG.defaultFrequency);
}

// Fetch product data to check available selling plans
async function getProductSellingPlans(productHandle) {
  try {
    const response = await fetch(`/products/${productHandle}.js`);
    if (!response.ok) {
      log(`Failed to fetch product data for ${productHandle}`);
      return null;
    }
    const product = await response.json();
    log(`Product data for ${productHandle}:`, {
      title: product.title,
      has_selling_plan_groups: !!(
        product.selling_plan_groups && product.selling_plan_groups.length > 0
      ),
      selling_plan_groups: product.selling_plan_groups,
    });
    return product.selling_plan_groups || [];
  } catch (error) {
    log("Error fetching product selling plans:", error);
    return null;
  }
}

// Debug logger
function log(...args) {
  if (CONFIG.debug) {
    console.log("[CartDrawer]", ...args);
  }
}

// Products that should not appear in cart (order protection, gifts, etc.)
const EXCLUDED_PRODUCTS = ["order protection", "sample", "free item"];

// ============================================
// DOM ELEMENT REFERENCES
// ============================================

function refreshCartLinesContainer() {
  const el = document.querySelector("#cartDrawer .cartLines");
  if (el) DOM.cartLinesContainer = el;
  return DOM.cartLinesContainer;
}

function refreshCartDrawerDOM() {
  refreshCartLinesContainer();
  const footer = document.querySelector(".cartDrawerFooter");
  if (footer) DOM.cartFooter = footer;
  const drawer = document.getElementById("cartDrawer");
  if (drawer) DOM.cartDrawer = drawer;
}

const DOM = {
  cartDrawer: document.getElementById("cartDrawer"),
  closeCartButton: document.querySelector(".closeCart"),
  cartFooter: document.querySelector(".cartDrawerFooter"),
  cartTotal: document.querySelector(".cartTotal"),
  cartFinalPrice: document.querySelector(".finalPrice"),
  cartDiscountedPrice: document.querySelector(".discountedPrice"),
  cartLinesContainer: document.querySelector("#cartDrawer .cartLines"),
  cartDiscountForm: document.querySelector("#cartDiscountForm"),
  cartDiscountInput: document.querySelector(".cartDiscountInput"),
  cartDiscountsFlex: document.querySelector(".discountsFlex") || null,
  cartDiscountsCtn: document.querySelector(".discountsCtn"),
  cartOpenButton: document.querySelector("#OpenCartDrawer"),
  giftNudgeCartCtn: document.querySelector(".giftNudgeCartCtn"),
  riskFreeNudgeCtn: document.querySelector(".riskFreeNudgeCtn"),
  freeShippingCtn: document.querySelector("#free-shipping"),
  cartItemCount: document.querySelector(".js-cart-item-count"),
};

// ============================================
// STATE MANAGEMENT
// ============================================

const state = {
  currentCart: null,
  cartQuantities: [],
  discountsArray: [],
};

const productVariantCache = {};
const compareAtByVariantId = new Map();

// ============================================
// HELPER FUNCTIONS - Product Filtering
// ============================================

function isMysteryGift(item) {
  if (item.properties?._mystery_gift) return true;
  const giftVariant = document.querySelector("[data-cart-milestones]")?.dataset
    .giftVariant;
  return !!giftVariant && String(item.variant_id) === giftVariant;
}

function shouldExcludeProduct(item) {
  // Hide TBYB subscription swap item from cart display
  if (
    String(item.variant_id) === String(CONFIG.tbybVariants.subscriptionSwapItem)
  ) {
    log("TBYB swap item excluded from display:", item.product_title);
    return true;
  }

  if (isMysteryGift(item)) return false;

  const productTitle = (item.product_title || "").toLowerCase();
  const variantTitle = (item.variant_title || "").toLowerCase();

  // "... Gift" free items only, not "Gift Set" bundles
  const isExcluded =
    /\bgift$/.test(productTitle) ||
    EXCLUDED_PRODUCTS.some(
      (excluded) =>
        productTitle.includes(excluded) || variantTitle.includes(excluded),
    );

  if (isExcluded) {
    log("Product excluded:", item.product_title);
  }

  return isExcluded;
}

// Shopify splits one line in two when a discount needs only part of its quantity (Mystery Gift BXGY)
function isSplitTwin(shown, item) {
  return (
    String(shown.variant_id) === String(item.variant_id) &&
    shown.final_price === item.final_price &&
    shown.selling_plan_allocation?.selling_plan?.id ===
      item.selling_plan_allocation?.selling_plan?.id &&
    compareProperties(shown.properties, item.properties)
  );
}

function mergeSplitLines(shown, item) {
  const sum = (field) => (shown[field] || 0) + (item[field] || 0);
  return {
    ...shown,
    quantity: sum("quantity"),
    line_price: sum("line_price"),
    original_line_price: sum("original_line_price"),
    final_line_price: sum("final_line_price"),
    total_discount: sum("total_discount"),
    line_level_total_discount: sum("line_level_total_discount"),
    line_level_discount_allocations: [
      ...(shown.line_level_discount_allocations || []),
      ...(item.line_level_discount_allocations || []),
    ],
    split_keys: [...(shown.split_keys || [shown.key]), item.key],
  };
}

// A merged row answers to the key of any of its split lines
function findCartLine(cart, key) {
  return cart?.items.find(
    (item) => item.key === key || item.split_keys?.includes(key),
  );
}

function filterCartItems(cart) {
  if (!cart || !cart.items || !Array.isArray(cart.items)) {
    log("Warning: Invalid cart data in filterCartItems", cart);
    return cart || { items: [] };
  }

  const originalCount = cart.items.length;
  const excludedItems = cart.items.filter((item) => shouldExcludeProduct(item));
  const includedItems = cart.items.filter(
    (item) => !shouldExcludeProduct(item),
  );

  // LPOfferGiftConfig gift variants legitimately repeat when 2+ bundles each grant a free unit (see syncGiftQuantities)
  const multiInstanceAllowedIds = new Set(
    Object.values(window.LPOfferGiftConfig || {})
      .flat()
      .map(String),
  );
  const seenVariantIds = new Set();
  const deduplicatedItems = [];
  const duplicateItems = [];

  for (const item of includedItems) {
    const vid = String(item.variant_id);
    // BOGO splits one quantity into a full-price line and a 50% line of the same variant
    if (multiInstanceAllowedIds.has(vid) || isMysteryGift(item) || isBogoLine(item)) {
      deduplicatedItems.push(item);
      continue;
    }
    const twinIndex = deduplicatedItems.findIndex((shown) => isSplitTwin(shown, item));
    if (twinIndex !== -1) {
      deduplicatedItems[twinIndex] = mergeSplitLines(deduplicatedItems[twinIndex], item);
    } else if (seenVariantIds.has(vid) && !item.final_line_price) {
      // A free extra line of the same variant (e.g. bundle gift-tracking item) stays hidden
      duplicateItems.push(item);
    } else {
      seenVariantIds.add(vid);
      deduplicatedItems.push(item);
    }
  }

  const excludedTotal = excludedItems.reduce(
    (sum, item) => sum + (item.final_line_price || 0),
    0,
  );

  const filtered = {
    ...cart,
    items: deduplicatedItems,
    total_price: cart.total_price - excludedTotal,
    full_total_price: cart.total_price,
  };

  log(
    `Filtered cart: ${originalCount} items -> ${filtered.items.length} items (${duplicateItems.length} variant-id duplicates hidden)`,
  );
  return filtered;
}

// ============================================
// HELPER FUNCTIONS - Offer Badges
// ============================================

function getOfferDiscountPercent(item) {
  const mrpUnit =
    item.variant_compare_at_price ||
    compareAtByVariantId.get(String(item.variant_id));
  if (!mrpUnit || mrpUnit <= item.price) return null;
  return Math.round((1 - item.price / mrpUnit) * 100);
}

// Mirrors the crossed-out vs current price pair rendered by createPriceHTML
function getLineSavePercent(item) {
  if (isGiftVariant(item) || isTBYBVariant(item)) return null;
  let was = item.variant_compare_at_price || 0;
  let now = item.final_price;
  if (item.selling_plan_allocation) {
    was = item.selling_plan_allocation.compare_at_price;
    now = item.discounted_price;
  } else if (item.original_price && item.original_price !== item.final_price) {
    was = item.original_price;
  } else if (
    item.line_price !== item.original_line_price &&
    item.original_line_price > 0
  ) {
    was = item.original_line_price;
    now = item.line_price;
  }
  if (!was || was <= now) return null;
  return Math.round((1 - now / was) * 100);
}

// Limited-time-offer badges are scoped to the page.LP_HS_Main template only, per manager request
function isLPHSMainTemplate() {
  return DOM.cartDrawer?.dataset.lpHsMain === "true";
}

function isHalloweenCart() {
  return DOM.cartDrawer?.dataset.halloween === "true";
}

// ============================================
// HELPER FUNCTIONS - Money Formatting
// ============================================

function formatMoneyCart(
  amountInCents,
  currencyCode = "USD",
  locale = "en-US",
) {
  const amount = amountInCents / 100;
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode,
  }).format(amount);
}

async function getProductVariantData(handle) {
  if (!handle) return null;

  if (!productVariantCache[handle]) {
    productVariantCache[handle] = fetch(`/products/${handle}.js`, {
      cache: "force-cache",
      credentials: "same-origin",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch product ${handle}`);
        }
        return response.json();
      })
      .then((product) => product.variants || [])
      .catch((error) => {
        log("[CartDrawer] Compare-at lookup failed:", error);
        return [];
      });
  }

  return productVariantCache[handle];
}

async function enrichCartItemsWithCompareAt(cart) {
  if (!cart || !Array.isArray(cart.items)) return cart;

  await Promise.all(
    cart.items.map(async (item) => {
      const variants = await getProductVariantData(item.handle);
      const variant = variants.find(
        (variantItem) => String(variantItem.id) === String(item.variant_id),
      );

      if (variant && variant.compare_at_price > variant.price) {
        item.variant_compare_at_price = variant.compare_at_price;
        compareAtByVariantId.set(String(item.variant_id), variant.compare_at_price);
      }
    }),
  );

  return cart;
}

// ============================================
// HELPER FUNCTIONS - Cart Item Utilities
// ============================================

function getVariantColor(title) {
  if (!title) return "#ffffff";
  if (title.includes("Blueberry")) return "#5050FE";
  if (title.includes("Peach")) return "#FFB74B";
  return "#ffffff";
}

function getImageUrl(imageUrl, size = CONFIG.imageSize) {
  return imageUrl.replace(/(\.[a-z]{3,4})(\?.*)?$/, `_${size}x${size}$1`);
}

// Check if a product/variant is eligible for subscriptions
function isSubscriptionEligible(item) {
  const config = CONFIG.subscriptionEligibility;
  const productTitle = (item.product_title || "").toLowerCase();
  const productHandle = (item.handle || "").toLowerCase();
  const productVariantID = item.variant_id || "";

  log("Checking subscription eligibility for:", item.product_title);

  // First, check exclude lists (these take priority)
  // Check if product title contains any excluded keywords
  const isExcludedByTitle = config.excludeByTitle.some((keyword) =>
    productTitle.includes(keyword.toLowerCase()),
  );

  if (isExcludedByTitle) {
    log("Product excluded by title keyword:", item.product_title);
    return false;
  }

  // Check if product handle is in exclude list
  if (config.excludeByHandle.includes(productHandle)) {
    log("Product excluded by handle:", productHandle);
    return false;
  }

  // If defaultEligible is true, all non-excluded products are eligible
  if (config.defaultEligible) {
    log("Product eligible (default eligible mode):", item.product_title);
    return true;
  }

  // If defaultEligible is false, check if product is in allow list
  const isInAllowList = config.allowList.some(
    (keyword) =>
      productTitle.includes(keyword.toLowerCase()) ||
      productVariantID == keyword,
  );

  if (isInAllowList) {
    log("Product eligible (in allow list):", item.product_title);
    return true;
  }

  log("Product not eligible (not in allow list):", item.product_title);
  return false;
}

function compareProperties(propsA, propsB) {
  propsA = propsA || {};
  propsB = propsB || {};
  const keysA = Object.keys(propsA);
  const keysB = Object.keys(propsB);

  if (keysA.length !== keysB.length) return false;

  return keysA.every((key) => String(propsA[key]) === String(propsB[key]));
}

// ============================================
// HELPER FUNCTIONS - Discounts
// ============================================

function combineDiscounts(discounts) {
  return discounts.join(",");
}

function updateDiscountsDisplay(cart) {
  if (!DOM.cartDiscountsFlex) return; // Skip if discount section doesn't exist

  state.discountsArray = cart.discount_codes.map((code) =>
    code.code.toUpperCase(),
  );
  DOM.cartDiscountsFlex.innerHTML = state.discountsArray
    .map((code, index) => createDiscountCodeHTML(code, index))
    .join("");
  attachButtonListeners(DOM.cartDiscountsFlex);
}

// ============================================
// HELPER FUNCTIONS - Price Display
// ============================================

function isTBYBDueLater(item) {
  // Subscription TBYB variant has no selling plan — detect by variant ID
  if (String(item.variant_id) === String(CONFIG.tbybVariants.subscription)) {
    return true;
  }
  const itemPlanId =
    item.selling_plan_allocation &&
    String(item.selling_plan_allocation.selling_plan.id);
  return (
    !!itemPlanId &&
    CONFIG.tbybSellingPlanIds.some((id) => String(id) === itemPlanId)
  );
}

function updatePriceDisplay(cart) {
  // cart.items here is always the filtered list (order protection / dupes / TBYB swap already dropped by filterCartItems)
  let tbybTotal = 0;
  let dueNowMrpTotal = 0;
  let visibleItemCount = 0;

  cart.items.forEach((item) => {
    visibleItemCount += item.quantity;

    if (isTBYBDueLater(item)) {
      tbybTotal += item.final_line_price;
      return;
    }

    // True MRP (compare_at_price) — a bundle's own SKU price already IS the discounted price
    const mrpUnit =
      item.variant_compare_at_price ||
      compareAtByVariantId.get(String(item.variant_id)) ||
      item.price;
    dueNowMrpTotal += mrpUnit * item.quantity;
  });

  // Display the actual amount due now (total price minus TBYB items)
  const amountDueNow = cart.total_price - tbybTotal;
  if (isHalloweenCart()) {
    renderHalloweenSummary(cart, amountDueNow, visibleItemCount);
    return;
  }
  DOM.cartFinalPrice.innerHTML = formatMoneyCart(amountDueNow);

  if (DOM.cartDiscountedPrice) {
    DOM.cartDiscountedPrice.innerHTML =
      dueNowMrpTotal > amountDueNow ? formatMoneyCart(dueNowMrpTotal) : "";
  }

  if (DOM.cartItemCount) {
    DOM.cartItemCount.textContent = `(${visibleItemCount} ${visibleItemCount === 1 ? "item" : "items"})`;
  }
}

// ============================================
// HELPER FUNCTIONS - State Updates
// ============================================

function updateState(cart) {
  state.currentCart = cart;
  state.cartQuantities = cart.items.map((item) => item.quantity);
}

function resetRowIndices() {
  const lines = Array.from(DOM.cartLinesContainer.querySelectorAll("li"));
  lines.forEach((line, index) => {
    const elementsWithIndex = line.querySelectorAll("[data-index]");
    elementsWithIndex.forEach((el) => el.setAttribute("data-index", index));
  });
}

function toggleButtonsState(parent, disabled) {
  const container = parent || DOM.cartLinesContainer;
  const buttons = container.querySelectorAll("button");
  buttons.forEach((button) => (button.disabled = disabled));
}

function updateSellingPlanText(item, row) {
  // Update the selling plan text
  const sellingPlanText = row.querySelector(".sellingPlanRow");
  if (!sellingPlanText) return;

  if (isHalloweenCart()) {
    sellingPlanText.textContent = getHalloweenPlanLabel(item);
    return;
  }

  if (item.selling_plan_allocation) {
    // Check if this is a TBYB item
    const isTBYB =
      item.selling_plan_allocation.selling_plan.name
        ?.toLowerCase()
        .includes("try") ||
      item.selling_plan_allocation.selling_plan.name
        ?.toLowerCase()
        .includes("tbyb");

    if (isTBYB) {
      sellingPlanText.textContent = "Try Before You Buy";
    } else {
      sellingPlanText.textContent = "Subscribe and Save";
    }
  } else {
    sellingPlanText.textContent = "One-Time Purchase";
  }
}

// ============================================
// GIFT NUDGE FUNCTIONS
// ============================================

/**
 * Count 4oz products in cart
 * @param {Object} cart - Cart object
 * @returns {number} Count of 4oz items
 */
function countFourOunceItems(cart) {
  let count = 0;
  cart.items.forEach((item) => {
    // Check specific SKUs if configured
    const itemSku = item.variant_sku || item.sku;
    if (
      CONFIG.fourOzSkus.length &&
      itemSku &&
      CONFIG.fourOzSkus.indexOf(itemSku) > -1
    ) {
      count += item.quantity;
      return;
    }

    // Check variant title for 4oz/4 oz/4-oz/4 ounce
    const variantTitle = String(item.variant_title || "").toLowerCase();
    if (/\b4\s*oz\b|4[-\s]?ounce/.test(variantTitle)) {
      count += item.quantity;
    }

    // Special case: Flare Care Duo counts as 2 items
    if (item.product_title.includes("Flare Care Duo")) {
      count += item.quantity * 2;
    }
  });

  log(`[Gift Nudge] Counted ${count} 4oz items in cart`);
  return count;
}

/**
 * Check if cart has any TBYB items
 * Uses CONFIG.tbybSellingPlanIds for type-safe matching
 * @param {Object} cart - Cart object
 * @returns {boolean} True if cart has TBYB item
 */
function hasTBYBInCart(cart) {
  log(`[TBYB Check] Checking TBYB`);

  if (!cart || !cart.items) return false;

  const hasTBYB = cart.items.some((item) => {
    // Check subscription TBYB by variant ID (no selling plan on this variant)
    if (String(item.variant_id) === String(CONFIG.tbybVariants.subscription)) {
      log(`[TBYB Check] Found subscription TBYB item: ${item.product_title}`);
      return true;
    }

    if (!item.selling_plan_allocation) return false;

    const itemPlanId = String(item.selling_plan_allocation.selling_plan.id);
    const isTBYB = CONFIG.tbybSellingPlanIds.some(
      (id) => String(id) === itemPlanId,
    );

    if (isTBYB) {
      log(
        `[TBYB Check] Found TBYB item: ${item.product_title}, Plan ID: ${itemPlanId}`,
      );
    }

    return isTBYB;
  });

  log(`[Gift Nudge] Cart has TBYB item: ${hasTBYB}`);
  return hasTBYB;
}

/**
 * Create gift nudge HTML
 * @param {number} fourOzCount - Number of 4oz items in cart
 * @returns {string} HTML string for gift nudge
 */

function updateGiftNudgeMessaging(fourOzCount) {
  const giftMessageElement = document.querySelector(".pGiftMessage");
  const giftRailElement = document.querySelector(".pGiftProgress");

  if (!giftMessageElement || !giftRailElement) {
    log("[Gift Nudge] Gift message or progress bar element not found");
    return;
  }
  if (fourOzCount >= 2) {
    giftMessageElement.innerHTML =
      "<span>FREE GIFT</span> is added to your order 🎁";
    giftRailElement.style.background = "rgb(71, 174, 0)";
    giftRailElement.style.transform = "scaleX(1)";
  } else if (fourOzCount === 1) {
    giftMessageElement.innerHTML =
      "One more 4oz to get a <span>FREE GIFT</span> 🎁";
    giftRailElement.style.background = "rgba(145, 145, 145, 1)";
    giftRailElement.style.transform = "scaleX(0.5)";
  } else if (fourOzCount === 0) {
    giftMessageElement.innerHTML =
      "Add two 4oz to get a <span>FREE GIFT</span> 🎁";
    giftRailElement.style.background = "rgba(145, 145, 145, 1)";
    giftRailElement.style.transform = "scaleX(0)";
  }
}
function createGiftNudgeHTML(fourOzCount) {
  const progressPercent = Math.min((fourOzCount / 2) * 100, 100);
  const progressColor =
    fourOzCount >= 2 ? "rgb(71, 174, 0)" : "rgba(145, 145, 145, 1)";

  let message = "";
  if (fourOzCount >= 2) {
    message = "<span>FREE GIFT</span> is added to your order 🎁";
  } else if (fourOzCount === 1) {
    message = "One more 4oz to get a <span>FREE GIFT</span> 🎁";
  } else {
    message = "Add two 4oz to get a <span>FREE GIFT</span> 🎁";
  }

  // Use configured image URL or default
  const imageUrl =
    CONFIG.giftProduct.image ||
    "/cdn/shop/files/0e015eefd62879b5b924afe07594322cc68e0f72_1_200x.png?v=1759607793";

  return `
    <div class="pGiftCtn inside">
      <div class="pGiftDiv reverse">
        <div class="pGiftInfo">
          <div class="pGiftImageCtn">
            <img src="${imageUrl}" alt="Universal Flare Care Gift" class="pGiftImage" loading="lazy">
          </div>
          <div class="pGiftTitleCtn">
            <p class="pGiftMessage">${message}</p>
            <div class="pGiftProgressCtn">
              <div class="pGiftProgressRail">
                <div class="pGiftProgress" style="transform: scaleX(${
                  progressPercent / 100
                }); background: ${progressColor};"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
}

/**
 * Update gift nudge display based on cart state
 * @param {Object} cart - Cart object
 */
function updateCartDrawerGiftNudge(cart) {
  log("[CartDrawer] updateCartDrawerGiftNudge ENTERED");

  // Re-query the container in case it was added to DOM after initial load
  const giftNudgeContainer =
    DOM.giftNudgeCartCtn || document.querySelector(".giftNudgeCartCtn");
  const riskFreeNudgeCtn =
    DOM.riskFreeNudgeCtn || document.querySelector(".riskFreeNudgeCtn");

  log("[CartDrawer] giftNudgeContainer:", giftNudgeContainer);

  // Update the cached reference if we found it
  if (!DOM.giftNudgeCartCtn && giftNudgeContainer) {
    DOM.giftNudgeCartCtn = giftNudgeContainer;
  }

  // Hide gift nudge if there's a TBYB item in cart
  const hasTBYB = hasTBYBInCart(cart);
  log("[CartDrawer] TBYB check result:", hasTBYB);

  const freeShippingCtn =
    DOM.freeShippingCtn || document.querySelector("#free-shipping");

  if (hasTBYB) {
    log("[CartDrawer] HIDING gift nudge because TBYB in cart");
    if (giftNudgeContainer) {
      giftNudgeContainer.style.setProperty("display", "none", "important");
      giftNudgeContainer.setAttribute("hidden", "true");
    }
    if (riskFreeNudgeCtn) {
      riskFreeNudgeCtn.style.setProperty("display", "block", "important");
      riskFreeNudgeCtn.removeAttribute("hidden");
    }
    if (freeShippingCtn) {
      freeShippingCtn.style.setProperty("display", "none", "important");
    }
    return;
  }

  if (riskFreeNudgeCtn) {
    riskFreeNudgeCtn.style.setProperty("display", "none", "important");
    riskFreeNudgeCtn.setAttribute("hidden", "true");
  }
  if (freeShippingCtn) {
    freeShippingCtn.style.setProperty("display", "block", "important");
  }

  // 1oz gift promo disabled — keep the nudge hidden unless re-enabled
  if (!GIFT_NUDGE_ENABLED || !giftNudgeContainer) {
    log("[CartDrawer] Gift nudge disabled or container not found - skipping");
    return;
  }

  const fourOzCount = countFourOunceItems(cart);

  // Show gift nudge
  giftNudgeContainer.style.setProperty("display", "block", "important");
  giftNudgeContainer.removeAttribute("hidden");

  // Update the messaging and progress bar
  updateGiftNudgeMessaging(fourOzCount);

  log(`[CartDrawer] Gift nudge SHOWN with ${fourOzCount} 4oz items`);
}
// ============================================
// API FUNCTIONS
// ============================================

async function fetchCart() {
  log("Fetching cart...");
  try {
    const response = await fetch("/cart.js", {
      cache: "no-store",
      credentials: "same-origin",
      keepalive: true,
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch cart: ${response.status}`);
    }

    const cart = await enrichCartItemsWithCompareAt(await response.json());
    log("Cart fetched:", cart);

    const filteredCart = filterCartItems(cart);
    updateState(filteredCart);
    return filteredCart;
  } catch (error) {
    log("Error fetching cart:", error);
    // Return empty cart on error
    const emptyCart = {
      items: [],
      item_count: 0,
      total_price: 0,
      total_discount: 0,
      original_total_price: 0,
      discount_codes: [],
    };
    updateState(emptyCart);
    return emptyCart;
  }
}

// A merged row stands for all its split lines, and a rejected change must never drop any of them
async function changeSplitLines(line, changeObject) {
  const post = (url, body) =>
    fetch(url, {
      method: "POST",
      cache: "no-store",
      credentials: "same-origin",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });

  if (!("selling_plan" in changeObject)) {
    const updates = Object.fromEntries(line.split_keys.map((key) => [key, 0]));
    updates[changeObject.id] = changeObject.quantity;
    const response = await post("/cart/update.js", { updates });
    return response.ok ? response.json() : null;
  }

  // Keys change as Shopify re-splits, so each next line still on the old plan is looked up again
  let cart = await (await fetch("/cart.js", { cache: "no-store" })).json();
  for (let step = 0; step < 10; step++) {
    const next = cart.items.find((item) => isSplitTwin(line, item));
    if (!next) break;
    const response = await post("/cart/change.js", {
      id: next.key,
      quantity: next.quantity,
      selling_plan: changeObject.selling_plan,
    });
    if (!response.ok) break;
    cart = await response.json();
  }
  return cart;
}

async function changeCartItem(changeObject) {
  log("Changing cart item:", changeObject);
  refreshCartDrawerDOM();
  DOM.cartFooter?.classList.add("active");
  try {
    const splitLine = findCartLine(state.currentCart, changeObject.id);
    if (splitLine?.split_keys) {
      const cart = await changeSplitLines(splitLine, changeObject);
      if (!cart) return await fetchCart();
      const filteredCart = filterCartItems(cart);
      updateState(filteredCart);
      return filteredCart;
    }

    const response = await fetch("/cart/change.js", {
      method: "POST",
      cache: "no-store",
      credentials: "same-origin",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(changeObject),
    });

    if (!response.ok) {
      // Get error details from response
      const errorText = await response.text();
      log(`Cart change failed with status ${response.status}:`, errorText);

      // Try to parse error details
      let errorDetails = errorText;
      try {
        const errorJson = JSON.parse(errorText);
        errorDetails = errorJson;
      } catch (e) {
        // Not JSON, use text as-is
      }

      log("Error details:", errorDetails);

      // Fetch cart anyway - sometimes Shopify returns an error but the change goes through
      log("Fetching cart to verify actual state...");
      return await fetchCart();
    }

    const cart = await response.json();
    log("Cart changed successfully:", cart);
    const filteredCart = filterCartItems(cart);
    updateState(filteredCart);
    return filteredCart;
  } catch (error) {
    log("Error changing cart item:", error);
    log("Change object that failed:", changeObject);
    // Fetch fresh cart on error to get actual state
    return await fetchCart();
  }
}

async function updateCart(updateObject) {
  log("Updating cart:", updateObject);
  refreshCartDrawerDOM();
  DOM.cartFooter?.classList.add("active");
  try {
    const response = await fetch("/cart/update.js", {
      method: "POST",
      cache: "no-store",
      credentials: "same-origin",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updateObject),
    });

    if (!response.ok) {
      throw new Error(`Failed to update cart: ${response.status}`);
    }

    const cart = await response.json();
    log("Cart updated:", cart);
    const filteredCart = filterCartItems(cart);
    updateState(filteredCart);
    return filteredCart;
  } catch (error) {
    log("Error updating cart:", error);
    // Fetch fresh cart on error
    return await fetchCart();
  }
}

// ============================================
// HTML TEMPLATE FUNCTIONS - Icons
// ============================================

const ICONS = {
  minus: `<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20"><path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"></path></svg>`,

  plus: `<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"></path></svg>`,

  trash: `<svg class="cartTrashIcon" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12.5" cy="12.5" r="12" stroke="var(--sg)"/>
    <path d="M4.5625 8.02344H20.4386" stroke="var(--sg)" stroke-linecap="round"/>
    <path d="M6.83984 8.02344V16.3149C6.83984 17.9586 8.17233 19.2911 9.81603 19.2911H15.1831C16.8269 19.2911 18.1593 17.9586 18.1593 16.3149V8.02344" stroke="var(--sg)" stroke-linecap="round"/>
    <path d="M10.6914 10.8281V16.4782M14.3079 10.8281V16.4782" stroke="var(--sg)" stroke-linecap="round"/>
  </svg>`,

  discountX: `<svg class="cartDiscountX" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 8.18359L8.49609 0.6875M8.49609 8.18359L1 0.6875" stroke="#5F5F5F" stroke-linecap="round"/>
  </svg>`,
  truck: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_6647_1184" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
<rect width="20" height="20" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_6647_1184)">
<path d="M6.04328 16.25C5.40689 16.25 4.86571 16.0272 4.41974 15.5817C3.97363 15.136 3.75057 14.5949 3.75057 13.9583H2.54391C2.36682 13.9583 2.21835 13.8984 2.09849 13.7785C1.97877 13.6587 1.91891 13.5102 1.91891 13.3331C1.91891 13.1559 1.97877 13.0075 2.09849 12.8879C2.21835 12.7682 2.36682 12.7083 2.54391 12.7083H4.18016C4.37349 12.391 4.63391 12.1381 4.96141 11.9496C5.28877 11.761 5.64905 11.6667 6.04224 11.6667C6.43543 11.6667 6.79578 11.761 7.12328 11.9496C7.45064 12.1381 7.71106 12.391 7.90453 12.7083H11.5679L13.3581 5H4.98453C4.80745 5 4.65905 4.94007 4.53932 4.82021C4.41946 4.70035 4.35953 4.55187 4.35953 4.37479C4.35953 4.19757 4.41946 4.04917 4.53932 3.92958C4.65905 3.80986 4.80745 3.75 4.98453 3.75H13.9749C14.2206 3.75 14.4188 3.84486 14.5695 4.03458C14.7201 4.22417 14.766 4.43757 14.7072 4.67479L14.1977 6.875H15.5293C15.7679 6.875 15.9939 6.92833 16.2072 7.035C16.4207 7.14181 16.5965 7.28931 16.7345 7.4775L18.2649 9.50813C18.4018 9.68646 18.4896 9.87687 18.5285 10.0794C18.5675 10.2817 18.5689 10.4903 18.5327 10.7052L18.0022 13.3558C17.9659 13.5342 17.8778 13.6792 17.7381 13.7908C17.5984 13.9025 17.4396 13.9583 17.2618 13.9583H16.571C16.571 14.594 16.3483 15.1349 15.9029 15.5808C15.4574 16.0269 14.9166 16.25 14.2804 16.25C13.6441 16.25 13.1029 16.0272 12.6568 15.5817C12.2109 15.136 11.9879 14.5949 11.9879 13.9583H8.33391C8.33391 14.594 8.1112 15.1349 7.66578 15.5808C7.22036 16.0269 6.67953 16.25 6.04328 16.25ZM13.2554 10.9375H17.2041L17.3195 10.3477L15.6577 8.125H13.9108L13.2554 10.9375ZM11.6897 12.2179L11.8116 11.6742C11.8927 11.3117 11.9958 10.8679 12.1208 10.3429C12.1731 10.125 12.2215 9.92361 12.2658 9.73875C12.3101 9.55389 12.3461 9.38778 12.3739 9.24042L12.4958 8.69667C12.577 8.33417 12.6802 7.89042 12.8052 7.36542C12.93 6.84042 13.0331 6.39667 13.1143 6.03417L13.2362 5.49042L13.3581 5L11.5679 12.7083L11.6897 12.2179ZM1.68328 10.9679C1.50842 10.9679 1.36189 10.908 1.2437 10.7881C1.1255 10.6683 1.06641 10.5198 1.06641 10.3427C1.06641 10.1655 1.12627 10.0171 1.24599 9.8975C1.36571 9.77778 1.51411 9.71792 1.6912 9.71792H4.59995C4.77703 9.71792 4.92543 9.77785 5.04516 9.89771C5.16502 10.0176 5.22495 10.1661 5.22495 10.3433C5.22495 10.5204 5.16502 10.6688 5.04516 10.7885C4.92543 10.9081 4.77703 10.9679 4.59995 10.9679H1.68328ZM3.34995 7.99042C3.17286 7.99042 3.02446 7.93049 2.90474 7.81062C2.78488 7.69076 2.72495 7.54229 2.72495 7.36521C2.72495 7.18799 2.78488 7.03951 2.90474 6.91979C3.02446 6.80021 3.17286 6.74042 3.34995 6.74042H7.09995C7.27703 6.74042 7.42543 6.80035 7.54516 6.92021C7.66502 7.04007 7.72495 7.18854 7.72495 7.36562C7.72495 7.54285 7.66502 7.69125 7.54516 7.81083C7.42543 7.93056 7.27703 7.99042 7.09995 7.99042H3.34995ZM6.04224 15C6.33182 15 6.5778 14.8987 6.78016 14.6962C6.98266 14.4939 7.08391 14.2479 7.08391 13.9583C7.08391 13.6687 6.98266 13.4228 6.78016 13.2204C6.5778 13.0179 6.33182 12.9167 6.04224 12.9167C5.75266 12.9167 5.50668 13.0179 5.30432 13.2204C5.10182 13.4228 5.00057 13.6687 5.00057 13.9583C5.00057 14.2479 5.10182 14.4939 5.30432 14.6962C5.50668 14.8987 5.75266 15 6.04224 15ZM14.2795 15C14.569 15 14.8149 14.8987 15.0174 14.6962C15.2199 14.4939 15.3212 14.2479 15.3212 13.9583C15.3212 13.6687 15.2199 13.4228 15.0174 13.2204C14.8149 13.0179 14.569 12.9167 14.2795 12.9167C13.9899 12.9167 13.7439 13.0179 13.5414 13.2204C13.3389 13.4228 13.2377 13.6687 13.2377 13.9583C13.2377 14.2479 13.3389 14.4939 13.5414 14.6962C13.7439 14.8987 13.9899 15 14.2795 15Z" fill="#744FE6"/>
</g>
</svg>
`,
  recurring: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_6647_1181" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
<rect width="20" height="20" fill="#5534EA"/>
</mask>
<g mask="url(#mask0_6647_1181)">
<path d="M6.04232 4.66043C5.17162 5.30362 4.50253 6.08786 4.03503 7.01314C3.56766 7.93828 3.33398 8.93397 3.33398 10.0002C3.33398 11.5654 3.80676 12.943 4.75232 14.1331C5.69773 15.3234 6.92155 16.1029 8.42378 16.4715C8.58405 16.5163 8.71329 16.6098 8.81148 16.7519C8.90982 16.894 8.95898 17.0494 8.95898 17.2181C8.95898 17.3869 8.89864 17.5277 8.77794 17.6404C8.65711 17.7531 8.52357 17.7913 8.37732 17.755C6.54496 17.3725 5.03801 16.4649 3.85648 15.0323C2.67482 13.5995 2.08398 11.9222 2.08398 10.0002C2.08398 8.76842 2.34016 7.6271 2.85253 6.57626C3.36475 5.52557 4.09843 4.61564 5.05357 3.84647H3.43815C3.26079 3.84647 3.11232 3.78661 2.99273 3.66689C2.87301 3.5473 2.81315 3.39883 2.81315 3.22147C2.81315 3.04411 2.87301 2.89557 2.99273 2.77585C3.11232 2.65626 3.26079 2.59647 3.43815 2.59647H6.53919C6.75391 2.59647 6.93308 2.66828 7.07669 2.81189C7.22044 2.95564 7.29232 3.13487 7.29232 3.3496V6.45064C7.29232 6.628 7.23246 6.77647 7.11273 6.89605C6.99315 7.01578 6.84468 7.07564 6.66732 7.07564C6.48996 7.07564 6.34148 7.01578 6.2219 6.89605C6.10218 6.77647 6.04232 6.628 6.04232 6.45064V4.66043ZM8.81315 11.7758L13.1032 7.48585C13.2272 7.36196 13.3722 7.30078 13.5384 7.3023C13.7045 7.30397 13.8522 7.36939 13.9815 7.49855C14.1022 7.62786 14.1647 7.77425 14.169 7.93772C14.1732 8.10119 14.1107 8.24758 13.9815 8.37689L9.34044 13.0179C9.18975 13.1685 9.01398 13.2438 8.81315 13.2438C8.61232 13.2438 8.43655 13.1685 8.28586 13.0179L6.01982 10.739C5.90454 10.6236 5.84343 10.4806 5.83648 10.3102C5.82954 10.1399 5.89065 9.99015 6.01982 9.86085C6.14065 9.74015 6.28704 9.6798 6.45898 9.6798C6.63093 9.6798 6.77732 9.74015 6.89815 9.86085L8.81315 11.7758ZM14.9477 16.1621H16.5632C16.7405 16.1621 16.889 16.2219 17.0086 16.3415C17.1283 16.4612 17.1882 16.6097 17.1882 16.7871C17.1882 16.9645 17.1283 17.1129 17.0086 17.2325C16.889 17.3522 16.7405 17.4121 16.5632 17.4121H13.4621C13.2474 17.4121 13.0682 17.3402 12.9246 17.1965C12.7809 17.0529 12.709 16.8736 12.709 16.6588V13.5579C12.709 13.3806 12.7688 13.232 12.8886 13.1123C13.0082 12.9927 13.1566 12.9329 13.334 12.9329C13.5113 12.9329 13.6598 12.9927 13.7794 13.1123C13.8991 13.232 13.959 13.3806 13.959 13.5579V15.3479C14.8244 14.691 15.4921 13.902 15.9621 12.9811C16.4322 12.0601 16.6673 11.0665 16.6673 10.0002C16.6673 8.43508 16.1945 7.05744 15.249 5.8673C14.3036 4.67703 13.0797 3.89758 11.5775 3.52897C11.4172 3.48411 11.288 3.39203 11.1898 3.25272C11.0915 3.11328 11.0423 2.95911 11.0423 2.79022C11.0423 2.62147 11.1027 2.47939 11.2234 2.36397C11.3442 2.24869 11.4777 2.20918 11.624 2.24543C13.4563 2.62251 14.9633 3.52876 16.1448 4.96418C17.3265 6.3996 17.9173 8.07828 17.9173 10.0002C17.9173 11.232 17.6611 12.3747 17.1488 13.4281C16.6366 14.4815 15.9029 15.3928 14.9477 16.1621Z" fill="#744FE6"/>
</g>
</svg>`,
  check: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_6647_1187" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
<rect width="20" height="20" fill="#5534EA"/>
</mask>
<g mask="url(#mask0_6647_1187)">
<path d="M8.81794 11.7882L6.88211 9.85218C6.76669 9.7369 6.62162 9.67787 6.4469 9.67509C6.27232 9.67245 6.12461 9.73148 6.00378 9.85218C5.88308 9.97301 5.82273 10.1194 5.82273 10.2913C5.82273 10.4633 5.88308 10.6097 6.00378 10.7305L8.29065 13.0174C8.44135 13.1679 8.61711 13.2432 8.81794 13.2432C9.01878 13.2432 9.19454 13.1679 9.34523 13.0174L13.9815 8.38113C14.0968 8.26572 14.1558 8.12065 14.1586 7.94592C14.1612 7.77134 14.1022 7.62363 13.9815 7.5028C13.8607 7.38211 13.7143 7.32176 13.5423 7.32176C13.3704 7.32176 13.224 7.38211 13.1032 7.5028L8.81794 11.7882ZM10.0021 17.9163C8.90711 17.9163 7.87787 17.7086 6.9144 17.293C5.95093 16.8775 5.11287 16.3135 4.40023 15.6011C3.6876 14.8888 3.12336 14.0511 2.70753 13.088C2.29183 12.125 2.08398 11.096 2.08398 10.0011C2.08398 8.90613 2.29176 7.8769 2.70732 6.91342C3.12287 5.94995 3.68683 5.1119 4.39919 4.39926C5.11155 3.68662 5.94926 3.12238 6.91232 2.70655C7.87537 2.29085 8.90433 2.08301 9.99919 2.08301C11.0942 2.08301 12.1234 2.29079 13.0869 2.70634C14.0504 3.1219 14.8884 3.68586 15.6011 4.39822C16.3137 5.11058 16.8779 5.94829 17.2938 6.91134C17.7095 7.8744 17.9173 8.90335 17.9173 9.99822C17.9173 11.0932 17.7095 12.1225 17.294 13.0859C16.8784 14.0494 16.3145 14.8875 15.6021 15.6001C14.8897 16.3127 14.052 16.877 13.089 17.2928C12.1259 17.7085 11.097 17.9163 10.0021 17.9163ZM10.0007 16.6663C11.8618 16.6663 13.4382 16.0205 14.7298 14.7288C16.0215 13.4372 16.6673 11.8608 16.6673 9.99967C16.6673 8.13856 16.0215 6.56217 14.7298 5.27051C13.4382 3.97884 11.8618 3.33301 10.0007 3.33301C8.13954 3.33301 6.56315 3.97884 5.27148 5.27051C3.97982 6.56217 3.33398 8.13856 3.33398 9.99967C3.33398 11.8608 3.97982 13.4372 5.27148 14.7288C6.56315 16.0205 8.13954 16.6663 10.0007 16.6663Z" fill="#744FE6"/>
</g>
</svg>`,
};

// ============================================
// HTML TEMPLATE FUNCTIONS - Components
// ============================================

function getFrequencyFromSellingPlan(item) {
  if (
    !item ||
    !item.selling_plan_allocation ||
    !item.selling_plan_allocation.selling_plan
  ) {
    log("No selling plan allocation found, using default frequency");
    return CONFIG.defaultFrequency;
  }

  const planId = item.selling_plan_allocation.selling_plan.id;
  log(`Looking up frequency for plan ID: ${planId} (type: ${typeof planId})`);

  // Get product-specific selling plans, fallback to global config
  const productPlans =
    CONFIG.productSellingPlans[item.handle] || CONFIG.sellingPlans;

  // Find which frequency matches this plan ID (compare as numbers)
  for (const [freq, id] of Object.entries(productPlans)) {
    // Convert both to numbers for comparison
    if (Number(id) === Number(planId)) {
      log(`Detected frequency ${freq} for plan ID ${planId}`);
      return freq;
    }
  }

  // If not found in product-specific plans, also check global plans as fallback
  if (CONFIG.productSellingPlans[item.handle]) {
    for (const [freq, id] of Object.entries(CONFIG.sellingPlans)) {
      if (Number(id) === Number(planId)) {
        log(
          `Detected frequency ${freq} for plan ID ${planId} (global fallback)`,
        );
        return freq;
      }
    }
  }

  // If not found, try to extract from the plan name/description
  const planName = item.selling_plan_allocation.selling_plan.name || "";
  log(`Could not match plan ID ${planId}, plan name: "${planName}"`);

  return CONFIG.defaultFrequency;
}

function createDeliveryFrequencySelect(index, item = null) {
  const currentFrequency = item
    ? getFrequencyFromSellingPlan(item)
    : CONFIG.defaultFrequency;

  return `
    <div class="deliveryFrequencySelect">
    <div>
      <div class="cartSubRow">
        ${ICONS.check}
        Shipped every (x) month/s
      </div>
      <div class="cartSubRow">
        ${ICONS.truck}
        % OFF Future Shipments
      </div>
      <div class="cartSubRow">
        ${ICONS.recurring}
        Cancel/Pause Anytime
      </div>
    </div>
      <label for="delivery-freq-${index}">Delivery Frequency:</label>
      <select id="delivery-freq-${index}" class="cartDeliverySelect" data-index="${index}">
        ${CONFIG.deliveryFrequencies
          .map(
            (freq) => `
          <option value="${freq.value}" ${
            freq.value === currentFrequency ? "selected" : ""
          }>
            ${freq.label}
          </option>
        `,
          )
          .join("")}
      </select>
    </div>
  `;
}

/**
 * Check if an item is a TBYB product (has TBYB selling plan attached)
 * @param {Object} item - Cart item
 * @returns {boolean} True if item has a TBYB selling plan
 */
function isTBYBProduct(item) {
  if (!item.selling_plan_allocation) return false;

  const itemPlanId = String(item.selling_plan_allocation.selling_plan.id);
  return CONFIG.tbybSellingPlanIds.some((id) => String(id) === itemPlanId);
}

/**
 * Check if an item is on a subscription plan (not TBYB)
 * @param {Object} item - Cart item
 * @returns {boolean} True if item has a regular subscription selling plan
 */
function isSubscriptionProduct(item) {
  if (!item.selling_plan_allocation) return false;

  const itemPlanId = String(item.selling_plan_allocation.selling_plan.id);
  // Check if it matches any of the regular subscription plan IDs
  const isRegularSubscription = Object.values(CONFIG.sellingPlans).some(
    (id) => String(id) === itemPlanId,
  );
  return isRegularSubscription;
}

/**
 * Create TBYB toggle for switching between TBYB and Subscription
 * TBYB products always have a selling plan - either TBYB or subscription
 * @param {number} index - Cart item index
 * @param {Object} item - Cart item
 * @returns {string} HTML string for TBYB toggle
 */
function createTBYBToggle(index, item) {
  // Determine current state by checking the variant ID
  // If it's the subscription variant, the toggle should be checked
  const isOnSubscription =
    String(item.variant_id) === String(CONFIG.tbybVariants.subscription);

  log(
    `TBYB toggle state: variant_id=${item.variant_id}, subscription_variant=${CONFIG.tbybVariants.subscription}, isOnSubscription=${isOnSubscription}`,
  );

  return "";

  return `
     <div class="subscriptionToggleWrapper tbybToggleWrapper">
      <label class="toggleLabel">
        <input
          type="checkbox"
          class="tbybToggle"
          data-index="${index}"
          ${isOnSubscription ? "checked" : ""}
        >
        <span class="toggleSlider"></span>
        <span class="toggleText">Subscribe & Save</span>
      </label>
    </div>
  `;
}

function createSubscriptionToggle(index, item) {
  // Check if this is a TBYB product - render TBYB toggle instead
  // We need to check:
  // 1. If the item is on a TBYB selling plan
  // 2. If the item's variant ID matches one of the TBYB variants (OTP or subscription)
  // 3. If the item has a TBYB property set

  const itemVariantId = String(item.variant_id);
  const isTBYBVariant =
    itemVariantId === String(CONFIG.tbybVariants.otp) ||
    itemVariantId === String(CONFIG.tbybVariants.subscription);

  const itemPlanId = item.selling_plan_allocation
    ? String(item.selling_plan_allocation.selling_plan.id)
    : "";
  const isTBYBPlan = CONFIG.tbybSellingPlanIds.some(
    (id) => String(id) === itemPlanId,
  );

  // Check if this item has TBYB property (set when added from TBYB product page)
  const hasTBYBProperty =
    item.properties && (item.properties.TBYB || item.properties.tbyb);

  // If any of these conditions are true, this is a TBYB product
  if (isTBYBVariant || isTBYBPlan || hasTBYBProperty) {
    log(
      `TBYB product detected: variant=${isTBYBVariant}, plan=${isTBYBPlan}, property=${hasTBYBProperty}`,
    );
    return createTBYBToggle(index, item);
  }

  // Check if product is eligible for subscriptions
  if (!isSubscriptionEligible(item)) {
    log(`Product not eligible for subscriptions: ${item.product_title}`);
    return "";
  }

  // A one-time sale price (e.g. Prime Day) would be lost by switching to Subscribe & Save
  const hasProductDiscount = (item.line_level_discount_allocations || []).some(
    (allocation) => allocation.amount > 0,
  );
  if (!item.selling_plan_allocation && hasProductDiscount) {
    return "";
  }

  const isSubscription = !!item.selling_plan_allocation;
  const detailsId = `subscription-details-${index}`;
  const toggleLabel = `
    <label class="toggleLabel">
      <input
        type="checkbox"
        class="subscriptionToggle"
        data-index="${index}"
        ${isSubscription ? "checked" : ""}
      >
      <span class="toggleSlider"></span>
      <span class="toggleText">Subscribe & Save</span>
    </label>
  `;

  return `
    <div class="subscriptionToggleWrapper subscriptionToggleWrapper--compact">
      <div class="subscriptionToggleHeader">
        ${toggleLabel}
        <button
          type="button"
          class="subscriptionDetailsToggle"
          aria-expanded="false"
          aria-controls="${detailsId}"
          ${isSubscription ? "" : "hidden"}
        >
          More
        </button>
      </div>
      <div
        id="${detailsId}"
        class="deliveryFrequencyContainer"
        hidden
      >
        ${createDeliveryFrequencySelect(index, item)}
      </div>
    </div>
  `;
}

function updateSubscriptionDetailsVisibility(
  row,
  isSubscription,
  preserveExpanded = false,
) {
  const details = row.querySelector(".deliveryFrequencyContainer");
  if (!details) return;

  const detailsToggle = row.querySelector(".subscriptionDetailsToggle");
  if (!detailsToggle) {
    details.style.display = isSubscription ? "" : "none";
    return;
  }

  const wasExpanded =
    preserveExpanded &&
    detailsToggle.getAttribute("aria-expanded") === "true" &&
    !details.hidden;

  details.style.display = "";
  details.hidden = !isSubscription || !wasExpanded;
  detailsToggle.hidden = !isSubscription;
  detailsToggle.setAttribute("aria-expanded", String(wasExpanded));
  detailsToggle.textContent = wasExpanded ? "Less" : "More";
}

function handleSubscriptionDetailsToggle(button) {
  const wrapper = button.closest(".subscriptionToggleWrapper");
  const details = wrapper?.querySelector(".deliveryFrequencyContainer");
  if (!details) return;

  const isExpanded = button.getAttribute("aria-expanded") === "true";
  details.hidden = isExpanded;
  button.setAttribute("aria-expanded", String(!isExpanded));
  button.textContent = isExpanded ? "More" : "Less";
}

/**
 * Check if an item is a TBYB item by variant ID
 * @param {Object} item - Cart item
 * @returns {boolean} True if item's variant ID matches any TBYB variant
 */
function isTBYBVariant(item) {
  const variantId = String(item.variant_id);
  return (
    variantId === String(CONFIG.tbybVariants.otp) ||
    variantId === String(CONFIG.tbybVariants.subscription)
  );
}

function isGiftVariant(item) {
  if (isMysteryGift(item)) return true;
  const config = window.LPOfferGiftConfig;
  if (!config) return false;
  const vid = String(item.variant_id);
  return Object.values(config).some((gifts) => gifts.map(String).includes(vid));
}

function createPriceHTML(item, plain = false) {
  // Free gift — show strikethrough original price + green Free
  if (isGiftVariant(item) && !plain) {
    if (item.final_price === 0) {
      // Discount applied — show strikethrough original price
      const origPrice = item.original_line_price || item.compare_at_price;
      if (origPrice) {
        return `<span class="lineTotalSpan freeGiftPrice"><s>${formatMoneyCart(origPrice)}</s></span>`;
      }
      return `<span class="lineTotalSpan freeGiftPrice"><s>—</s></span>`;
    }
    // Discount not applied yet — show actual price (will update when Shopify applies discount)
    return `<span class="lineTotalSpan">${formatMoneyCart(item.line_price)}</span>`;
  }

  // Check if this is a TBYB item by variant ID (either OTP or subscription variant)
  const isTBYBItem = isTBYBVariant(item);

  // Debug logging
  log(
    `[TBYB Check] Item: ${item.product_title}, Variant ID: ${item.variant_id}, isTBYBVariant: ${isTBYBItem}, plain: ${plain}`,
  );

  // All TBYB variants show $0 Now (unless plain is true for "if you decide to keep" text)
  if (isTBYBItem && !plain) {
    return `<span class="lineTotalSpan tbybPrice">$0 Now</span>`;
  }

  // Check for subscription discount
  if (item.selling_plan_allocation && !plain) {
    return `
      <span class="lineTotalSpan discounted">
        ${formatMoneyCart(
          item.selling_plan_allocation.compare_at_price * item.quantity,
        )}
      </span>
      <span class="lineTotalSpan">
        ${formatMoneyCart(item.discounted_price * item.quantity)}
      </span>
    `;
  }

  // Check for OTP (one-time purchase) discount
  // If original_price exists and is different from final_price, show both
  if (item.original_price && item.original_price !== item.final_price) {
    return `
      <span class="lineTotalSpan discounted">
        ${formatMoneyCart(item.original_price * item.quantity)}
      </span>
      <span class="lineTotalSpan">
        ${formatMoneyCart(item.final_price * item.quantity)}
      </span>
    `;
  }

  // Check for line-level discount (discounts array or discount_allocations)
  if (
    item.line_price !== item.original_line_price &&
    item.original_line_price > 0
  ) {
    return `
      <span class="lineTotalSpan discounted">
        ${formatMoneyCart(item.original_line_price)}
      </span>
      <span class="lineTotalSpan">
        ${formatMoneyCart(item.line_price)}
      </span>
    `;
  }

  if (
    item.variant_compare_at_price &&
    item.variant_compare_at_price > item.final_price &&
    !plain
  ) {
    return `
      <span class="lineTotalSpan discounted">
        ${formatMoneyCart(item.variant_compare_at_price * item.quantity)}
      </span>
      <span class="lineTotalSpan">
        ${formatMoneyCart(item.final_price * item.quantity)}
      </span>
    `;
  }

  // No discount - show regular price
  return `<span class="lineTotalSpan">${formatMoneyCart(
    item.line_price,
  )}</span>`;
}

function createCartRowHTML(item, index) {
  if (isHalloweenCart()) return createHalloweenRowHTML(item, index);
  const hasSubscription = !!item.selling_plan_allocation;
  log(item);

  // Check if this is a TBYB item by variant ID
  const isTBYBItem = isTBYBVariant(item);
  // Check if it's on the OTP/TBYB plan (not subscription variant)
  const isOnTBYBPlan =
    String(item.variant_id) === String(CONFIG.tbybVariants.otp);

  const isFreeGift = isGiftVariant(item) && item.final_price === 0;
  const showLimitedOfferBadge =
    isLPHSMainTemplate() && !isFreeGift && !!getOfferDiscountPercent(item);
  const savePercent = isFreeGift ? null : getLineSavePercent(item);

  log(`[Cart Row] isTBYBItem: ${isTBYBItem}, isOnTBYBPlan: ${isOnTBYBPlan}, isFreeGift: ${isFreeGift}`);

  // Determine subscription text
  let subscriptionText;
  if (isFreeGift) {
    subscriptionText = `<span class="freeGiftLabel">🎁 Free</span>`;
  } else if (isTBYBItem) {
    subscriptionText = "$60.00" + " if you decide to keep";
  } else if (hasSubscription) {
    subscriptionText = "Subscribe and Save";
  } else {
    subscriptionText = "One-Time Purchase";
  }

  // Hide quantity buttons for TBYB or free gift items
  const hideQuantityButtons = isTBYBItem || isFreeGift;

  const variantTitleHTML = item.variant_title
    ? `
             <p class="cartLineVariant" style="background: ${getVariantColor(
               item?.variant_title,
             )}">
          <strong>${item.options_with_values[0].name}:</strong>
          ${item.options_with_values[0].value}
          </p>
            `
    : "";

  if (isFreeGift && isMysteryGift(item)) {
    const worth = item.original_line_price;
    const giftImage = item.featured_image?.url
      ? `<div class="cartLineImageCtn"></div>`
      : `<div class="cartLineImageCtn cartLineImageCtn--mystery">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <rect x="3.25" y="8" width="17.5" height="4.25" rx="1.1" />
            <path d="M5 12.25v7.1c0 .91.74 1.65 1.65 1.65h10.7c.91 0 1.65-.74 1.65-1.65v-7.1M12 8v13" />
            <path d="M12 8c-.7-2.6-2.1-4.5-3.8-4.5a2.25 2.25 0 0 0 0 4.5M12 8c.7-2.6 2.1-4.5 3.8-4.5a2.25 2.25 0 0 1 0 4.5" />
          </svg>
        </div>`;
    return `
    <div class="cartLineFlex">
      <div class="cartLineImageWrap">
        ${giftImage}
      </div>

      <div class="cartLineCtn cartLineCtn--gift">
        <div>
          <p class="cartLineTitle">Mystery Gift</p>
          ${worth ? `<p class="cartMysteryWorth">Worth ${formatMoneyCart(worth)}</p>` : ""}
          <p class="sellingPlanRow">${subscriptionText}</p>
        </div>
      </div>
    </div>
  `;
  }

  // Free gift rows: price sits inline with the Size line instead of its own
  // row at the bottom, so the card doesn't carry extra empty height
  if (isFreeGift) {
    return `
    <div class="cartLineFlex">
      <div class="cartLineImageWrap">
        <div class="cartLineImageCtn"></div>
      </div>

      <div class="cartLineCtn cartLineCtn--gift">
        <div>
          <p class="cartLineTitle">${item.product_title}</p>
          <div class="cartGiftMetaRow">
            ${variantTitleHTML}
            <p class="lineTotal">${createPriceHTML(item)}</p>
          </div>
          <p class="sellingPlanRow">${subscriptionText}</p>
        </div>
      </div>
    </div>
    ${createSubscriptionToggle(index, item)}
  `;
  }

  return `
    <div class="cartLineFlex">
      <div class="cartLineImageWrap">
        <div class="cartLineImageCtn"></div>
        ${savePercent ? `<span class="imageDiscountBadge">Save ${savePercent}%</span>` : ""}
      </div>

      <div class="cartLineCtn">
        <div>
          <p class="cartLineTitle">${item.product_title}</p>
          ${showLimitedOfferBadge ? `<span class="limitedOfferBadge">Limited Time Offer</span>` : ""}
          ${variantTitleHTML}
          <p class="sellingPlanRow">${subscriptionText}</p>
        </div>


          ${
            hideQuantityButtons
              ? `<div class="quantityAndPrice"><div></div><p class="lineTotal">${createPriceHTML(item)}</p></div>`
              : `<div class="quantityAndPrice">
                <div class="cartLineQuantityCtn">
                  <button type="button" class="subtract" data-index="${index}" data-minus>
                    ${ICONS.minus}
                  </button>
                  <span class="quantity" data-quantity="${item.quantity}">
                    ${item.quantity}
                  </span>
                  <button type="button" class="add" data-index="${index}" data-inc>
                    ${ICONS.plus}
                  </button>
                </div>
                <p class="lineTotal">${createPriceHTML(item)}</p>
              </div>`
          }

      </div>
    </div>
    ${createSubscriptionToggle(index, item)}
  `;
}

const HALLOWEEN_GIFT_ICON = `<svg viewBox="0 0 32 32" fill="none" aria-hidden="true" focusable="false"><path d="M5.333 10.667h21.334c.736 0 1.333.597 1.333 1.333v2.667c0 .736-.597 1.333-1.333 1.333H5.333A1.333 1.333 0 0 1 4 14.667V12c0-.736.597-1.333 1.333-1.333Z" stroke="currentColor" stroke-width="2.133" /><path d="M6.667 16v10.667H16m0 0h9.333V16M16 26.667v-16m0 0C13.333 5.333 8 5.333 8 8.667S13.333 10.667 16 10.667Zm0 0c2.667-5.334 8-5.334 8-2c0 3.333-5.333 2-8 2Z" stroke="currentColor" stroke-width="2.133" stroke-linejoin="round" /></svg>`;

function getHalloweenPlanLabel(item) {
  const planName = (item.selling_plan_allocation?.selling_plan?.name || "").toLowerCase();
  if (planName.includes("try") || planName.includes("tbyb")) return "Try Before You Buy";
  return item.selling_plan_allocation ? "Subscription" : "One-time";
}

function isBogoLine(item) {
  return (item.line_level_discount_allocations || []).some((allocation) =>
    /bogo/i.test(allocation.discount_application?.title || ""),
  );
}

function hasBogoDiscount(item) {
  return (item.line_level_discount_allocations || []).some(
    (allocation) =>
      allocation.amount > 0 &&
      /bogo/i.test(allocation.discount_application?.title || ""),
  );
}

function createHalloweenPriceHTML(item) {
  if (isTBYBVariant(item)) return createPriceHTML(item);
  const compareAt =
    item.selling_plan_allocation?.compare_at_price ||
    item.variant_compare_at_price ||
    compareAtByVariantId.get(String(item.variant_id)) ||
    0;
  const was = Math.max(item.original_line_price || 0, compareAt * item.quantity);
  const now = item.final_line_price;
  if (was > now) {
    return `<span class="lineTotalSpan discounted">${formatMoneyCart(was)}</span><span class="lineTotalSpan lineTotalSpan--sale">${formatMoneyCart(now)}</span>`;
  }
  return `<span class="lineTotalSpan">${formatMoneyCart(now)}</span>`;
}

function createHalloweenRowHTML(item, index) {
  const isFreeGift = isGiftVariant(item) && item.final_price === 0;

  if (isFreeGift && isMysteryGift(item)) {
    const goal = Number(
      document.querySelector("[data-cart-milestones]")?.dataset.gift || 0,
    );
    const goalLabel = formatMoneyCart(goal).replace(/\.00$/, "");
    return `
    <div class="cartLineFlex">
      <div class="cartGiftTile">${HALLOWEEN_GIFT_ICON}</div>
      <div class="cartLineCtn">
        <p class="cartLineTitle">Mystery gift</p>
        <p class="cartLineMeta">Surprise inside${goal ? ` · Free over ${goalLabel}` : ""}</p>
      </div>
      <p class="lineTotal">${item.original_line_price > 0 ? `<span class="lineTotalSpan discounted">${formatMoneyCart(item.original_line_price)}</span>` : ""}<span class="lineTotalSpan lineTotalSpan--free">Free</span></p>
    </div>
  `;
  }

  const size = item.variant_title ? item.options_with_values[0].value : "";
  const plan = `<span class="sellingPlanRow">${getHalloweenPlanLabel(item)}</span>`;
  const hideQuantityButtons = isTBYBVariant(item) || isFreeGift;

  return `
    <div class="cartLineFlex">
      <div class="cartLineImageWrap">
        <div class="cartLineImageCtn"></div>
      </div>

      <div class="cartLineCtn">
        <p class="cartLineTitle">${item.product_title}</p>
        <p class="cartLineMeta">${size ? `${size} · ` : ""}${plan}</p>
        ${hasBogoDiscount(item) ? `<span class="cartLineTag">BOGO 50% off</span>` : ""}
        ${
          hideQuantityButtons
            ? ""
            : `<div class="cartLineQuantityCtn">
                <button type="button" class="subtract" data-index="${index}" data-minus aria-label="Decrease quantity">−</button>
                <span class="quantity" data-quantity="${item.quantity}">${item.quantity}</span>
                <button type="button" class="add" data-index="${index}" data-inc aria-label="Increase quantity">+</button>
              </div>`
        }
      </div>

      <p class="lineTotal">${createHalloweenPriceHTML(item)}</p>
    </div>
    ${isFreeGift ? "" : createSubscriptionToggle(index, item)}
  `;
}

function renderHalloweenSummary(cart, total, itemCount) {
  const titleCount = document.querySelector("[data-cart-title-count]");
  if (titleCount) titleCount.textContent = itemCount ? ` (${itemCount})` : "";

  const discounts = new Map();
  const addDiscount = (title, amount) => {
    if (amount > 0) discounts.set(title, (discounts.get(title) || 0) + amount);
  };
  cart.items.forEach((item) => {
    if (isGiftVariant(item)) return;
    (item.line_level_discount_allocations || []).forEach((allocation) => {
      addDiscount(allocation.discount_application?.title || "Discount", allocation.amount);
    });
  });
  (cart.cart_level_discount_applications || []).forEach((application) => {
    addDiscount(application.title || "Discount", application.total_allocated_amount);
  });

  let saved = 0;
  discounts.forEach((amount) => (saved += amount));
  const row = (label, value, modifier) =>
    `<p class="cartSummary__row cartSummary__row--${modifier}"><span>${label}</span><span>${value}</span></p>`;
  const rows = [row("Subtotal", formatMoneyCart(total + saved), "subtotal")];
  discounts.forEach((amount, title) => {
    rows.push(row(title, `−${formatMoneyCart(amount)}`, "discount"));
  });

  const summary = document.querySelector("[data-cart-summary]");
  if (summary) summary.innerHTML = rows.join("");
  // Order Protection and other lines hidden from the list are still charged at checkout
  setHalloweenCheckoutTotal(
    total + (cart.full_total_price ?? cart.total_price) - cart.total_price,
  );
}

function setHalloweenCheckoutTotal(cents) {
  const checkoutTotal = document.querySelector("[data-checkout-total]");
  if (checkoutTotal) checkoutTotal.textContent = `\u00a0· ${formatMoneyCart(cents)}`;
}

// Order Protection updates itself and reports the full cart, so the checkout total follows it
document.addEventListener("cart:updated", (event) => {
  const cart = event.detail?.cart;
  if (!isHalloweenCart() || !Array.isArray(cart?.items) || "full_total_price" in cart) {
    return;
  }
  const dueLater = cart.items.reduce(
    (sum, item) => (isTBYBDueLater(item) ? sum + item.final_line_price : sum),
    0,
  );
  setHalloweenCheckoutTotal(cart.total_price - dueLater);
});

function createSkeletonRowHTML(hasSellingPlan = false) {
  return `
    <div class="cartLineFlex">
      <div class="cartLineImageCtn skeletonBox"></div>
      <div class="cartLineCtn">
        <div>
          <p class="cartLineTitle skeletonText"></p>
          <p class="cartLineVariant skeletonText"></p>
          <p class="sellingPlanRow skeletonText"></p>
        </div>
        <div class="cartLineQuantityCtn">
          <button class="subtract" disabled>${ICONS.minus}</button>
          <span class="quantity"></span>
          <button class="add" disabled>${ICONS.plus}</button>
        </div>
      </div>
      <div class="cartLineRight">
        <button class="deleteLine" disabled>${ICONS.trash}</button>
        <p class="lineTotal"><span class="lineTotalSpan skeletonText"></span></p>
      </div>
    </div>
    ${!hasSellingPlan ? '<div class="hasSellingPlanSkeleton"></div>' : ""}
  `;
}

function createDiscountCodeHTML(code, index) {
  return `
    <div class="discountCode">
      <span>${code}</span>
      <button data-discount data-index="${index}" class="discountCodeRemoveButton">
        ${ICONS.discountX}
      </button>
    </div>
  `;
}

function createEmptyCartHTML() {
  return `
    <li class="noCartItems">
      <span>No items in cart.</span>
      <a href="/" class="btn" aria-label="Shop now">Shop now</a>
    </li>
  `;
}

// ============================================
// RENDERING FUNCTIONS
// ============================================

function loadCartImage(container, item) {
  if (!container || !item.featured_image?.url) return;
  container.classList.add("loadingImage");
  const img = document.createElement("img");
  img.src = getImageUrl(item.featured_image.url);
  img.alt = item.product_title;
  img.classList.add("cartLineImage");

  img.onload = async () => {
    try {
      await img.decode();
    } catch (e) {
      warn("Image decode failed:", img.src);
    }
    container.appendChild(img);
    container.classList.remove("loadingImage");
  };
}

function createCartRow(item, index) {
  if (!item) {
    log("ERROR: createCartRow called with undefined item at index", index);
    throw new Error(
      `Cannot create cart row: item is undefined at index ${index}`,
    );
  }

  if (!item.key) {
    log("ERROR: Item missing 'key' property:", item);
    throw new Error(`Cannot create cart row: item.key is undefined`);
  }

  const li = document.createElement("li");
  li.classList.add("cartLine", "loadingNew");
  li.setAttribute("data-index", index);
  li.setAttribute("data-key", item.key);
  li.innerHTML = createCartRowHTML(item, index);

  setTimeout(() => li.classList.remove("loadingNew"), 10);

  return li;
}

function createSkeletonRow(hasSellingPlan = false) {
  const li = document.createElement("li");
  li.className = "cartLine cartLineSkeleton";
  li.innerHTML = createSkeletonRowHTML(hasSellingPlan);
  return li;
}

function renderSingleRow(cart, index) {
  refreshCartDrawerDOM();
  // A BOGO discount can move to another line when one quantity changes
  if (isHalloweenCart()) {
    renderFullCart(cart);
    attachButtonListeners();
    return;
  }
  const lines = Array.from(DOM.cartLinesContainer.querySelectorAll("li"));
  const row = lines[index];
  if (!row) {
    log(`renderSingleRow: Missing row at index ${index}, triggering full re-render`);
    renderFullCart(cart);
    attachButtonListeners();
    return;
  }
  // Look up by key so cart item reordering from the API never maps the wrong data to this row
  const item = findCartLine(cart, row.dataset.key) ?? cart.items[index];
  if (!item) {
    log(`renderSingleRow: Missing item for row at index ${index}, triggering full re-render`);
    renderFullCart(cart);
    attachButtonListeners();
    return;
  }

  // Update the data-key attribute to match the current cart item
  row.setAttribute("data-key", item.key);

  const quantity = row.querySelector(".quantity");
  const sellingPlanText = row.querySelector(".sellingPlanRow");
  const linePrice = row.querySelector(".lineTotal");

  if (quantity) {
    quantity.textContent = String(item.quantity);
    quantity.setAttribute("data-quantity", item.quantity);
  }

  // Update selling plan text
  updateSellingPlanText(item, row);

  if (linePrice) linePrice.innerHTML = createPriceHTML(item);

  // Update subscription toggle state and delivery frequency visibility
  const subscriptionToggle = row.querySelector(".subscriptionToggle");
  const deliveryFrequencyContainer = row.querySelector(
    ".deliveryFrequencyContainer",
  );

  if (subscriptionToggle) {
    subscriptionToggle.checked = !!item.selling_plan_allocation;
  }

  if (deliveryFrequencyContainer) {
    updateSubscriptionDetailsVisibility(
      row,
      !!item.selling_plan_allocation,
      true,
    );
  }

  updatePriceDisplay(cart);
}

function renderFullCart(cart) {
  log("[CartDrawer] renderFullCart called", cart);
  refreshCartDrawerDOM();
  if (!DOM.cartLinesContainer) return;
  DOM.cartLinesContainer.innerHTML = "";

  if (cart.items.length === 0) {
    DOM.cartLinesContainer.innerHTML = createEmptyCartHTML();
    DOM.cartFooter?.classList.remove("active");
    updateCartDrawerGiftNudge(cart);
    return;
  }

  // Debug: Log all cart items and their subscription data
  log(
    "Rendering cart with items:",
    cart.items.map((item, idx) => ({
      index: idx,
      title: item.product_title,
      variant: item.variant_title,
      variant_id: item.variant_id,
      handle: item.handle,
      has_selling_plan: !!item.selling_plan_allocation,
      selling_plan_id: item.selling_plan_allocation?.selling_plan?.id,
      has_available_plans: !!item.variant_available_selling_plan_allocations,
      requires_selling_plan: item.requires_selling_plan,
      // Log all keys to see what data is available
      available_keys: Object.keys(item),
    })),
  );

  cart.items.forEach((item, index) => {
    const row = createCartRow(item, index);
    DOM.cartLinesContainer.appendChild(row);

    const imageContainer = row.querySelector(".cartLineImageCtn");
    loadCartImage(imageContainer, item);
  });

  updatePriceDisplay(cart);
  updateDiscountsDisplay(cart);
  log("[CartDrawer] >>> ABOUT TO CALL updateCartDrawerGiftNudge <<<");
  updateCartDrawerGiftNudge(cart);
  DOM.cartFooter?.classList.add("active");
  ensureCartLinesDelegation();
  document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
}

function addNewRow(item, index) {
  const row = createCartRow(item, index);
  const skeleton = DOM.cartLinesContainer.querySelector(".cartLineSkeleton");

  if (skeleton) {
    skeleton.replaceWith(row);
  } else {
    const existingRow = DOM.cartLinesContainer.children[index];
    if (existingRow) {
      DOM.cartLinesContainer.insertBefore(row, existingRow);
    } else {
      DOM.cartLinesContainer.appendChild(row);
    }
  }

  const imageContainer = row.querySelector(".cartLineImageCtn");
  loadCartImage(imageContainer, item);
}

function removeRow(index) {
  const lines = Array.from(DOM.cartLinesContainer.querySelectorAll("li"));
  lines[index]?.remove();
}

function showEmptyCart() {
  DOM.cartLinesContainer.innerHTML = createEmptyCartHTML();
  DOM.cartFooter?.classList.remove("active");
  document.dispatchEvent(
    new CustomEvent("cart:updated", {
      detail: { cart: { items: [], item_count: 0, total_price: 0 } },
    }),
  );
}

// ============================================
// CART ACTION HANDLERS
// ============================================

function resolveCartLineButton(button, action) {
  refreshCartDrawerDOM();
  const container = DOM.cartLinesContainer;
  if (!container || !button) return null;

  const index = parseInt(button.getAttribute("data-index"), 10);
  const rowKey = button.closest("li.cartLine")?.dataset?.key;
  const selector =
    action === "inc"
      ? "button[data-inc]"
      : action === "minus"
        ? "button[data-minus]"
        : "button[data-delete]";

  if (rowKey) {
    const row = container.querySelector(`li.cartLine[data-key="${rowKey}"]`);
    const fromRow = row?.querySelector(selector);
    if (fromRow && container.contains(fromRow)) return fromRow;
  }

  if (!Number.isNaN(index)) {
    const fromIndex = container.querySelector(
      `${selector}[data-index="${index}"]`,
    );
    if (fromIndex && container.contains(fromIndex)) return fromIndex;
  }

  return container.contains(button) ? button : null;
}

async function handleQuantityChange(button, increase = true) {
  log(`Quantity change: ${increase ? "increase" : "decrease"}`);
  refreshCartDrawerDOM();
  if (!DOM.cartLinesContainer) return;

  DOM.cartFooter?.classList.add("active");

  const action = increase ? "inc" : "minus";
  button = resolveCartLineButton(button, action) || button;

  const lines = Array.from(DOM.cartLinesContainer.querySelectorAll("li"));
  const index = parseInt(button.getAttribute("data-index"), 10);
  let row = button.closest("li.cartLine") || lines[index];

  if (!row) {
    log(`Error: Row at index ${index} not found`);
    return;
  }

  const key = row.dataset.key;
  if (!key) {
    log(`Error: No key found for row at index ${index}`);
    return;
  }

  row.classList.add("loading");
  toggleButtonsState(row, true);

  try {
    // Derive current quantity by key so reordered cart state never sends the wrong value
    const currentItem = findCartLine(state.currentCart, key);
    const currentQty = currentItem
      ? currentItem.quantity
      : (state.cartQuantities[index] ?? 1);
    const newQty = currentQty + (increase ? 1 : -1);
    const isZero = newQty === 0;

    state.cartQuantities[index] = newQty;
    log(`New quantity for item ${index}: ${newQty}, key: ${key}`);

    const updatedCart = await changeCartItem({
      id: key,
      quantity: newQty,
    });

    if (isZero) {
      log("Item quantity is zero, removing from cart");
      const syncedCart = await syncGiftQuantities(updatedCart);
      if (syncedCart.items.length === 0) {
        showEmptyCart();
        updateDiscountsDisplay(syncedCart);
        updatePriceDisplay(syncedCart);
        updateCartDrawerGiftNudge(syncedCart);
      } else {
        renderFullCart(syncedCart);
        attachButtonListeners();
        updatePriceDisplay(syncedCart);
        updateCartDrawerGiftNudge(syncedCart);
      }
    } else {
      renderSingleRow(updatedCart, index);
      updateCartDrawerGiftNudge(updatedCart);

      const updatedLines = Array.from(
        DOM.cartLinesContainer.querySelectorAll("li"),
      );
      row = updatedLines[index];

      if (row) {
        toggleButtonsState(row, false);
      }
    }

    document.dispatchEvent(
      new CustomEvent("cart:updated", { detail: { cart: updatedCart } }),
    );
  } catch (error) {
    log("Error in handleQuantityChange:", error);
    console.error("[CartDrawer] handleQuantityChange:", error);
    if (row) {
      toggleButtonsState(row, false);
    }
  } finally {
    if (row) {
      row.classList.remove("loading");
    }
  }
}

// Syncs gift quantities based on which bundles are in cart (window.LPOfferGiftConfig).
// Additive: each bundle in cart contributes its own copy of each gift it lists,
// multiplied by that bundle's cart quantity.
// Example: Double(gift1) + Ultimate(gift1,gift2) both qty 1 in cart → gift1=2, gift2=1.
async function syncGiftQuantities(cart) {
  const config = window.LPOfferGiftConfig;
  if (!config || Object.keys(config).length === 0) return cart;

  const allGiftIds = new Set(Object.values(config).flat().map(String));
  const needed = {};
  for (const gid of allGiftIds) needed[gid] = 0;

  for (const [mainVid, giftIds] of Object.entries(config)) {
    const mainItem = cart.items.find((i) => String(i.variant_id) === String(mainVid));
    if (mainItem && mainItem.quantity > 0) {
      for (const gid of giftIds) {
        needed[String(gid)] = (needed[String(gid)] || 0) + mainItem.quantity;
      }
    }
  }

  let changed = false;
  for (const [gid, neededQty] of Object.entries(needed)) {
    const giftItem = cart.items.find((i) => String(i.variant_id) === String(gid));
    const currentQty = giftItem ? giftItem.quantity : 0;
    if (currentQty === neededQty) continue;
    changed = true;
    if (neededQty === 0 && giftItem) {
      await changeCartItem({ id: giftItem.key, quantity: 0 });
    } else if (neededQty > 0 && !giftItem) {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: parseInt(gid), quantity: neededQty }),
      });
    } else if (giftItem && giftItem.quantity !== neededQty) {
      await changeCartItem({ id: giftItem.key, quantity: neededQty });
    }
  }

  return changed ? await fetchCart() : cart;
}

async function handleDeleteItem(button) {
  const lines = Array.from(DOM.cartLinesContainer.querySelectorAll("li"));
  const index = parseInt(button.getAttribute("data-index"));
  const row = lines[index];

  log(`Deleting item at index ${index}`);

  toggleButtonsState(row, true);
  row.classList.add("loading");

  state.cartQuantities[index] = 0;

  let updatedCart = await changeCartItem({
    id: row.dataset.key,
    quantity: 0,
  });

  updatedCart = await syncGiftQuantities(updatedCart);

  if (updatedCart.items.length === 0) {
    log("Cart is now empty");
    showEmptyCart();
    updateDiscountsDisplay(updatedCart);
    updatePriceDisplay(updatedCart);
    updateCartDrawerGiftNudge(updatedCart);
  } else {
    renderFullCart(updatedCart);
    attachButtonListeners();
    updatePriceDisplay(updatedCart);
    updateCartDrawerGiftNudge(updatedCart);
  }

  document.dispatchEvent(
    new CustomEvent("cart:updated", { detail: { cart: updatedCart } }),
  );
}

async function handleSubscriptionToggle(checkbox) {
  const index = parseInt(checkbox.getAttribute("data-index"));
  const row = checkbox.closest("li");
  const isChecked = checkbox.checked;

  log(`Subscription toggle at index ${index}: ${isChecked ? "ON" : "OFF"}`);

  // Prevent multiple toggles at once
  if (row.classList.contains("loading")) {
    log("Already processing, ignoring toggle");
    checkbox.checked = !isChecked; // Revert the checkbox
    return;
  }

  toggleButtonsState(row, true);
  row.classList.add("loading");

  const item = state.currentCart.items[index];

  // Check if product is eligible
  if (!isSubscriptionEligible(item)) {
    log("Product not eligible for subscriptions");
    alert("This product is not eligible for subscriptions.");
    checkbox.checked = false;
    row.classList.remove("loading");
    toggleButtonsState(row, false);
    return;
  }

  // Log detailed item info
  log("Item being toggled:", {
    product: item.product_title,
    variant: item.variant_title,
    quantity: item.quantity,
    variant_id: item.variant_id,
    key: item.key,
    current_selling_plan:
      item.selling_plan_allocation?.selling_plan?.id || "none",
    has_selling_plan_allocation: !!item.selling_plan_allocation,
  });

  let updatedCart;

  // Get product-specific selling plans, fallback to global config
  const productPlans =
    CONFIG.productSellingPlans[item.handle] || CONFIG.sellingPlans;
  log(`Using selling plans for ${item.handle}:`, productPlans);

  if (isChecked) {
    // Switch to subscription with default plan (2 months / 60 days)
    const defaultPlanId =
      productPlans[CONFIG.defaultFrequency] || productPlans["60"];

    log(
      `Switching to subscription with plan ID: ${defaultPlanId} (${CONFIG.defaultFrequency} days)`,
    );

    if (!defaultPlanId) {
      log("ERROR: Selling plan IDs not configured for this product!");
      alert("Subscription plans are not configured for this product.");
      checkbox.checked = false;
      row.classList.remove("loading");
      toggleButtonsState(row, false);
      return;
    }

    // Apply selling plan
    updatedCart = await changeCartItem({
      id: item.key,
      quantity: item.quantity,
      selling_plan: Number(defaultPlanId),
    });

    log("Cart after enabling subscription:", updatedCart);
  } else {
    // Switch to one-time purchase by clearing the selling plan
    log("Switching to one-time purchase - clearing selling plan");

    updatedCart = await changeCartItem({
      id: item.key,
      quantity: item.quantity,
      selling_plan: "",
    });

    log("Cart after disabling subscription:", updatedCart);
  }

  // Verify cart was returned
  if (!updatedCart || !updatedCart.items) {
    log("ERROR: Invalid cart returned from changeCartItem");
    checkbox.checked = !isChecked;
    row.classList.remove("loading");
    toggleButtonsState(row, false);
    return;
  }

  // Capture old cart length BEFORE updating state
  const oldCartLength = state.cart ? state.cart.items.length : 0;

  // Update state with the new cart
  updateState(updatedCart);

  log("Cart updated, keys comparison:");
  log(
    "New cart items:",
    updatedCart.items.map((i) => ({ key: i.key, title: i.product_title })),
  );
  log("Original item key:", item.key);
  log("Cart length changed:", oldCartLength, "->", updatedCart.items.length);

  // CRITICAL: If cart line count changed, Shopify combined or split items
  // We need to do a full re-render to handle this
  if (updatedCart.items.length !== oldCartLength) {
    log(
      "Cart line count changed - doing full re-render to handle combined/split items",
    );
    renderFullCart(updatedCart);
    attachButtonListeners();
    updatePriceDisplay(updatedCart);
    updateCartDrawerGiftNudge(updatedCart);
    return;
  }

  // CRITICAL: When toggling selling plan, Shopify may change the item's key
  // Find the updated item by matching variant_id + properties (since multiple items can have same variant_id)
  const updatedItem = updatedCart.items.find((cartItem) => {
    // Match by variant_id first
    if (cartItem.variant_id !== item.variant_id) return false;

    // Then match by properties to handle multiple items with same variant
    return compareProperties(cartItem.properties, item.properties);
  });

  if (!updatedItem || isHalloweenCart()) {
    log(
      "ERROR: Could not find updated item in cart, falling back to full re-render",
    );
    renderFullCart(updatedCart);
    attachButtonListeners();
    updatePriceDisplay(updatedCart);
    updateCartDrawerGiftNudge(updatedCart);
    return;
  }

  log("Updated item found:", {
    old_key: item.key,
    new_key: updatedItem.key,
    key_changed: item.key !== updatedItem.key,
    has_plan: !!updatedItem.selling_plan_allocation,
    plan_id: updatedItem.selling_plan_allocation?.selling_plan?.id,
  });

  // Update the row's data-key if it changed
  if (item.key !== updatedItem.key) {
    log(`Item key changed from ${item.key} to ${updatedItem.key}`);
    row.setAttribute("data-key", updatedItem.key);
  }

  // Update selling plan text
  updateSellingPlanText(updatedItem, row);

  // Update the price display
  const linePrice = row.querySelector(".lineTotal");
  if (linePrice) {
    linePrice.innerHTML = createPriceHTML(updatedItem);
  }

  // Toggle the delivery frequency selector visibility
  const deliveryFrequencyContainer = row.querySelector(
    ".deliveryFrequencyContainer",
  );
  if (deliveryFrequencyContainer) {
    updateSubscriptionDetailsVisibility(row, isChecked);
  }

  // Update the checkbox state to match
  checkbox.checked = !!updatedItem.selling_plan_allocation;

  updatePriceDisplay(updatedCart);
  updateCartDrawerGiftNudge(updatedCart);
  row.classList.remove("loading");
  toggleButtonsState(row, false);

  log("Subscription toggle complete - row updated in place");
}

/**
 * Handle TBYB toggle - switches between TBYB selling plan and 60-day subscription
 * Also switches the variant ID between OTP and Subscription variants
 * TBYB products always have a selling plan, never OTP without a plan
 * @param {HTMLInputElement} checkbox - The toggle checkbox element
 */
async function handleTBYBToggle(checkbox) {
  const index = parseInt(checkbox.getAttribute("data-index"));
  const row = checkbox.closest("li");
  const isChecked = checkbox.checked; // checked = subscription, unchecked = TBYB

  log(`TBYB toggle at index ${index}: ${isChecked ? "SUBSCRIPTION" : "TBYB"}`);

  // Prevent multiple toggles at once
  if (row.classList.contains("loading")) {
    log("Already processing, ignoring toggle");
    checkbox.checked = !isChecked; // Revert the checkbox
    return;
  }

  toggleButtonsState(row, true);
  row.classList.add("loading");

  const item = state.currentCart.items[index];

  // Log detailed item info
  log("TBYB item being toggled:", {
    product: item.product_title,
    variant: item.variant_title,
    quantity: item.quantity,
    variant_id: item.variant_id,
    key: item.key,
    current_selling_plan:
      item.selling_plan_allocation?.selling_plan?.id || "none",
  });

  let updatedCart;
  let newPlanId;
  let newVariantId;

  // Get the TBYB product's selling plans from config
  const tbybPlans = CONFIG.productSellingPlans[CONFIG.tbybHandle];
  if (!tbybPlans) {
    log("ERROR: TBYB product selling plans not configured!");
    alert("TBYB product is not configured in productSellingPlans.");
    checkbox.checked = !isChecked;
    row.classList.remove("loading");
    toggleButtonsState(row, false);
    return;
  }

  if (isChecked) {
    // Switch to 60-day subscription variant + plan (using TBYB product's 60-day plan)
    newPlanId = tbybPlans["60"];
    newVariantId = CONFIG.tbybVariants.subscription;
    log(
      `Switching TBYB item to subscription: variant ${newVariantId}, plan ${newPlanId}`,
    );
  } else {
    // Switch to TBYB OTP variant + TBYB selling plan
    newPlanId = tbybPlans.tbyb;
    newVariantId = CONFIG.tbybVariants.otp;
    log(`Switching to TBYB: variant ${newVariantId}, plan ${newPlanId}`);
  }

  if (!newPlanId) {
    log("ERROR: Selling plan ID not configured for TBYB product!");
    alert("Selling plan is not configured properly for TBYB product.");
    checkbox.checked = !isChecked;
    row.classList.remove("loading");
    toggleButtonsState(row, false);
    return;
  }

  if (!newVariantId) {
    log("ERROR: TBYB variant ID not configured!");
    alert(
      "TBYB variant IDs are not configured. Please update CONFIG.tbybVariants.",
    );
    checkbox.checked = !isChecked;
    row.classList.remove("loading");
    toggleButtonsState(row, false);
    return;
  }

  log("[TBYB] Passed validation, entering try block...");
  log("[TBYB] Using TBYB product plans:", tbybPlans);

  // We need to remove the old item and add the new variant with the new selling plan
  // because we're changing both the variant AND the selling plan
  try {
    log("[TBYB] === Starting toggle ===");
    log("[TBYB] Current item key:", item.key);
    log("[TBYB] Current variant_id:", item.variant_id);
    log("[TBYB] Target variant_id:", newVariantId);
    log("[TBYB] Target selling_plan:", newPlanId);

    // Step 1: Remove the old item using direct fetch
    log("[TBYB] Step 1: Removing old item...");
    const removeResponse = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({
        id: item.key,
        quantity: 0,
      }),
    });
    const removeData = await removeResponse.json();
    log("[TBYB] Remove response:", removeResponse.status, removeData);

    // Step 2: Add the new variant with the new selling plan
    // Step 2: Add the new variant with quantity always set to 1
    // TBYB items are limited to 1 per cart regardless of variant
    log("[TBYB] Step 2: Adding new item with quantity: 1 (TBYB limit)");
    const addPayload = {
      items: [
        {
          id: Number(newVariantId),
          quantity: 1, // TBYB items always quantity 1
          selling_plan: Number(newPlanId),
        },
      ],
    };
    log("[TBYB] Add payload:", JSON.stringify(addPayload));

    const addResponse = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(addPayload),
    });

    const addData = await addResponse.json();
    log("[TBYB] Add response:", addResponse.status, addData);

    if (!addResponse.ok) {
      throw new Error(
        `Failed to add: ${addResponse.status} - ${JSON.stringify(addData)}`,
      );
    }

    // Fetch the updated cart
    updatedCart = await fetchCart();
    log("[TBYB] Toggle complete. New cart:", updatedCart);
  } catch (error) {
    error("[TBYB] *** CATCH BLOCK HIT ***");
    error("[TBYB] Error object:", error);
    error("[TBYB] Error message:", error?.message);
    // Try to restore the original item (always quantity 1 for TBYB)
    try {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({
          items: [
            {
              id: item.variant_id,
              quantity: 1, // TBYB items always quantity 1
              selling_plan: item.selling_plan_allocation?.selling_plan?.id
                ? Number(item.selling_plan_allocation.selling_plan.id)
                : undefined,
              properties: item.properties || {},
            },
          ],
        }),
      });
      updatedCart = await fetchCart();
    } catch (restoreError) {
      error("[TBYB] Restore error:", restoreError);
    }
    checkbox.checked = !isChecked;
    row.classList.remove("loading");
    toggleButtonsState(row, false);
    alert("Failed to switch (v2). Please try again.");
    return;
  }

  // Verify cart was returned
  if (!updatedCart || !updatedCart.items) {
    log("ERROR: Invalid cart returned");
    checkbox.checked = !isChecked;
    row.classList.remove("loading");
    toggleButtonsState(row, false);
    return;
  }

  // Update state with the new cart
  updateState(updatedCart);

  // Since we removed and added an item, always do a full re-render
  log("TBYB toggle complete - doing full re-render");
  renderFullCart(updatedCart);
  attachButtonListeners();
  updatePriceDisplay(updatedCart);
  updateCartDrawerGiftNudge(updatedCart);
}

async function handleDeliveryFrequencyChange(select) {
  const index = parseInt(select.getAttribute("data-index"));
  const frequency = select.value;
  const row = select.closest("li");

  log(`Delivery frequency changed to ${frequency} for item ${index}`);

  // Prevent changes while loading
  if (row.classList.contains("loading")) {
    log("Already processing, ignoring frequency change");
    return;
  }

  toggleButtonsState(row, true);
  row.classList.add("loading");

  const item = state.currentCart.items[index];

  // Get product-specific selling plans, fallback to global config
  const productPlans =
    CONFIG.productSellingPlans[item.handle] || CONFIG.sellingPlans;
  const newPlanId = productPlans[frequency];

  log(`Using selling plans for ${item.handle}:`, productPlans);

  if (!newPlanId) {
    log(
      `ERROR: No selling plan ID for frequency ${frequency} for product ${item.handle}`,
    );
    alert(
      `Subscription plan for ${frequency} is not configured for this product.`,
    );
    row.classList.remove("loading");
    toggleButtonsState(row, false);
    return;
  }

  log(`Switching to plan ID: ${newPlanId} (${frequency})`);

  const updatedCart = await changeCartItem({
    id: item.key,
    quantity: item.quantity,
    selling_plan: Number(newPlanId),
  });

  if (!updatedCart || !updatedCart.items) {
    log("ERROR: Invalid cart returned");
    row.classList.remove("loading");
    toggleButtonsState(row, false);
    alert("Failed to update delivery frequency. Please try again.");
    return;
  }

  // Capture old cart length BEFORE updating state
  const oldCartLength = state.cart ? state.cart.items.length : 0;

  // Update state
  updateState(updatedCart);

  // CRITICAL: If cart line count changed, Shopify combined or split items
  // We need to do a full re-render to handle this
  if (updatedCart.items.length !== oldCartLength) {
    log(
      "Cart line count changed - doing full re-render to handle combined/split items",
    );
    renderFullCart(updatedCart);
    attachButtonListeners();
    updatePriceDisplay(updatedCart);
    updateCartDrawerGiftNudge(updatedCart);
    return;
  }

  // Find the updated item (key might have changed)
  const updatedItem = updatedCart.items.find((cartItem) => {
    if (cartItem.variant_id !== item.variant_id) return false;
    return compareProperties(cartItem.properties, item.properties);
  });

  if (!updatedItem || isHalloweenCart()) {
    log("ERROR: Could not find updated item, falling back to full re-render");
    renderFullCart(updatedCart);
    attachButtonListeners();
    updatePriceDisplay(updatedCart);
    return;
  }

  log("Updated item found after frequency change:", {
    old_key: item.key,
    new_key: updatedItem.key,
    key_changed: item.key !== updatedItem.key,
    new_plan_id: updatedItem.selling_plan_allocation?.selling_plan?.id,
  });

  // Update the row's data-key if it changed
  if (item.key !== updatedItem.key) {
    log(`Item key changed from ${item.key} to ${updatedItem.key}`);
    row.setAttribute("data-key", updatedItem.key);
  }

  // Update selling plan text
  updateSellingPlanText(updatedItem, row);

  // Update the price display
  const linePrice = row.querySelector(".lineTotal");
  if (linePrice) {
    linePrice.innerHTML = createPriceHTML(updatedItem);
  }

  // Update the delivery frequency select to match (in case it was adjusted)
  const deliverySelect = row.querySelector(".cartDeliverySelect");
  if (deliverySelect) {
    deliverySelect.value = frequency;
  }

  updatePriceDisplay(updatedCart);
  row.classList.remove("loading");
  toggleButtonsState(row, false);

  log("Delivery frequency change complete - row updated in place");
}

async function handleAddDiscount() {
  if (!DOM.cartDiscountsCtn || !DOM.cartDiscountInput) return; // Skip if discount elements don't exist

  DOM.cartDiscountsCtn.classList.add("loading");

  const newCode = DOM.cartDiscountInput.value.trim();
  if (!newCode) {
    DOM.cartDiscountsCtn.classList.remove("loading");
    return;
  }

  state.discountsArray.push(newCode);

  const updatedCart = await updateCart({
    discount: combineDiscounts(state.discountsArray),
  });

  DOM.cartDiscountInput.value = "";
  updateDiscountsDisplay(updatedCart);
  updatePriceDisplay(updatedCart);
  DOM.cartDiscountsCtn.classList.remove("loading");
}

async function handleRemoveDiscount(button) {
  if (!DOM.cartDiscountsCtn) return; // Skip if discount elements don't exist

  DOM.cartDiscountsCtn.classList.add("loading");

  const index = parseInt(button.getAttribute("data-index"));
  state.discountsArray.splice(index, 1);

  const updatedCart = await updateCart({
    discount: combineDiscounts(state.discountsArray),
  });

  updateDiscountsDisplay(updatedCart);
  updatePriceDisplay(updatedCart);
  DOM.cartDiscountsCtn.classList.remove("loading");
}

// ============================================
// EVENT HANDLERS
// ============================================

function handleButtonClick(e) {
  e.preventDefault();
  const button = e.currentTarget;

  if (button.hasAttribute("data-inc")) {
    handleQuantityChange(button, true);
  } else if (button.hasAttribute("data-minus")) {
    handleQuantityChange(button, false);
  } else if (button.hasAttribute("data-delete")) {
    handleDeleteItem(button);
  } else if (button.hasAttribute("data-discount")) {
    handleRemoveDiscount(button);
  }
}

function handleCartLinesDelegatedClick(e) {
  const button = e.target.closest(
    "button[data-inc], button[data-minus], button[data-delete]",
  );
  if (!button || button.disabled) return;

  refreshCartDrawerDOM();
  if (!DOM.cartLinesContainer?.contains(button)) return;

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  const action = button.hasAttribute("data-inc")
    ? "inc"
    : button.hasAttribute("data-minus")
      ? "minus"
      : "delete";
  const index = button.getAttribute("data-index");
  const rowKey = button.closest("li.cartLine")?.dataset?.key;

  queueMicrotask(async () => {
    try {
      refreshCartDrawerDOM();
      const activeButton = resolveCartLineButton(button, action);
      if (!activeButton) {
        log("Cart line button could not be resolved after click", {
          action,
          index,
          rowKey,
        });
        return;
      }

      if (action === "inc") {
        await handleQuantityChange(activeButton, true);
      } else if (action === "minus") {
        await handleQuantityChange(activeButton, false);
      } else {
        await handleDeleteItem(activeButton);
      }
    } catch (error) {
      console.error("[CartDrawer] Line action failed:", error);
    }
  });
}

function ensureCartLinesDelegation() {
  refreshCartDrawerDOM();
  const root = document.documentElement;
  root.removeEventListener("click", handleCartLinesDelegatedClick, true);
  root.addEventListener("click", handleCartLinesDelegatedClick, true);
  if (DOM.cartLinesContainer) {
    DOM.cartLinesContainer.dataset.clickDelegated = "1";
  }
}

function attachButtonListeners(parent) {
  refreshCartLinesContainer();
  const container = parent || DOM.cartLinesContainer;
  if (!container) return;

  if (!parent || parent === DOM.cartLinesContainer) {
    ensureCartLinesDelegation();
  } else {
    container.querySelectorAll("button[data-discount]").forEach((button) => {
      if (button.dataset.bound) return;
      button.dataset.bound = "1";
      button.addEventListener("click", handleButtonClick);
    });
  }

  // Attach subscription toggle listeners
  const toggles = container.querySelectorAll(".subscriptionToggle");
  log(`Attaching listeners to ${toggles.length} subscription toggles`);
  toggles.forEach((toggle) => {
    if (toggle.dataset.bound) {
      log(`Toggle already bound at index ${toggle.dataset.index}`);
      return;
    }
    toggle.dataset.bound = "1";
    toggle.addEventListener("change", (e) => {
      log(`Toggle changed event fired for index ${e.target.dataset.index}`);
      handleSubscriptionToggle(e.target);
    });
    log(`Attached listener to toggle at index ${toggle.dataset.index}`);
  });

  const detailsToggles = container.querySelectorAll(
    ".subscriptionDetailsToggle",
  );
  detailsToggles.forEach((button) => {
    if (button.dataset.bound) return;
    button.dataset.bound = "1";
    button.addEventListener("click", () =>
      handleSubscriptionDetailsToggle(button),
    );
  });

  // Attach delivery frequency listeners
  const selects = container.querySelectorAll(".cartDeliverySelect");
  log(`Attaching listeners to ${selects.length} delivery frequency selects`);
  selects.forEach((select) => {
    if (select.dataset.bound) {
      log(`Select already bound at index ${select.dataset.index}`);
      return;
    }
    select.dataset.bound = "1";
    select.addEventListener("change", (e) => {
      log(
        `Frequency select changed event fired for index ${e.target.dataset.index}`,
      );
      handleDeliveryFrequencyChange(e.target);
    });
    log(`Attached listener to select at index ${select.dataset.index}`);
  });

  // Attach TBYB toggle listeners
  const tbybToggles = container.querySelectorAll(".tbybToggle");
  log(`Attaching listeners to ${tbybToggles.length} TBYB toggles`);
  tbybToggles.forEach((toggle) => {
    if (toggle.dataset.bound) {
      log(`TBYB toggle already bound at index ${toggle.dataset.index}`);
      return;
    }
    toggle.dataset.bound = "1";
    toggle.addEventListener("change", (e) => {
      log(
        `TBYB toggle changed event fired for index ${e.target.dataset.index}`,
      );
      handleTBYBToggle(e.target);
    });
    log(`Attached TBYB listener to toggle at index ${toggle.dataset.index}`);
  });
}

// ============================================
// CART DRAWER CONTROLS
// ============================================
window.cartDrawerOpen = openCartDrawer;
window.cartDrawerClose = closeCartDrawer;
window.initializeCartDrawer = initializeCartDrawer;
// Called from lp-hs-offer section after adding main bundle variant
function renderCartState(cart) {
  if (cart.items.length === 0) {
    showEmptyCart();
  } else {
    renderFullCart(cart);
    attachButtonListeners();
  }
  updatePriceDisplay(cart);
  updateCartDrawerGiftNudge(cart);
}
window.syncLPGifts = async function () {
  let cart = await fetchCart();
  cart = await syncGiftQuantities(cart);
  renderCartState(cart);
};
window.refreshCartDrawer = async function () {
  renderCartState(await fetchCart());
};
function openCartDrawer() {
  // STAGE 2: while the Recharge cart drawer experience is live it owns the cart
  // UI — never show the native drawer alongside it. Every open path (cart icon,
  // ATC forms, ab-bundle-cards, addToCartPopupSeries, LP pages) funnels through
  // here. Inert on the live theme / funnel templates where the Recharge config
  // is absent. Rollback: delete the next two lines (or just turn the "Cart" app
  // embed off — that removes the config and the native drawer returns).
  var rc = window.RechargeStorefrontConfig;
  if (rc && rc.cart_drawer && rc.cart_drawer.enabled) return;
  DOM.cartDrawer.classList.add("open");
  document.body.classList.add("noScroll");
}

function closeCartDrawer() {
  DOM.cartDrawer.classList.remove("open");
  document.body.classList.remove("noScroll");
}

async function initializeCartDrawer(e) {
  e && e.preventDefault();
  log("[CartDrawer] initializeCartDrawer called");
  log(
    "[CartDrawer] data-mutated:",
    DOM.cartDrawer?.getAttribute("data-mutated"),
  );
  openCartDrawer();

  if (DOM.cartDrawer.getAttribute("data-mutated") === "false") {
    log("[CartDrawer] First time opening cart, fetching data...");
    DOM.cartDrawer.setAttribute("data-mutated", "true");
    const cart = await fetchCart();
    document.dispatchEvent(
      new CustomEvent("cart:updated", { detail: { cart } }),
    );

    if (cart.items.length === 0) {
      log("[CartDrawer] Cart is empty");
      showEmptyCart();
    } else {
      log(`[CartDrawer] Rendering cart with ${cart.items.length} items`);
      renderFullCart(cart);
      attachButtonListeners();
    }
  } else {
    log("[CartDrawer] Cart already initialized - re-rendering fresh cart");
    const cart = await fetchCart();
    if (cart.items.length === 0) {
      showEmptyCart();
    } else {
      renderFullCart(cart);
      attachButtonListeners();
    }
    updatePriceDisplay(cart);
    updateDiscountsDisplay(cart);
    updateCartDrawerGiftNudge(cart);
  }
}

async function openCartAfterAdd(addedItem) {
  // log("Opening cart after item added:", addedItem);
  const noItemsElement = DOM.cartLinesContainer.querySelector(".noCartItems");
  if (noItemsElement) {
    noItemsElement.remove();
  }

  openCartDrawer();

  if (DOM.cartDrawer.dataset.mutated === "false") {
    log("First add to cart, initializing...");
    DOM.cartDrawer.setAttribute("data-mutated", "true");
    const cart = await fetchCart();
    if (cart.items.length === 0) {
      showEmptyCart();
    } else {
      renderFullCart(cart);
      attachButtonListeners();
    }
    updatePriceDisplay(cart);
    updateDiscountsDisplay(cart);
    updateCartDrawerGiftNudge(cart);
    if (cart.items.length > 0) {
      DOM.cartFooter?.classList.add("active");
    }
    return;
  }

  const previousCart = state.currentCart;
  const cart = await fetchCart();

  document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));

  // If cart item count changed (new item added or items merged/split), do full re-render
  if (!previousCart || previousCart.items.length !== cart.items.length) {
    log("Cart item count changed, doing full re-render");
    renderFullCart(cart);
    attachButtonListeners();

    updatePriceDisplay(cart);
    updateDiscountsDisplay(cart);
    updateCartDrawerGiftNudge(cart);

    if (cart.items.length > 0) {
      DOM.cartFooter?.classList.add("active");
    }

    document.dispatchEvent(
      new CustomEvent("cart:updated", { detail: { cart } }),
    );
    return;
  }

  // Cart has same number of items - compare each item to see what changed
  log("Cart item count unchanged, checking for changes...");
  const changedIndices = [];

  cart.items.forEach((newItem, index) => {
    const oldItem = previousCart.items.find((item) => item.key === newItem.key);

    if (!oldItem) {
      // Item key not found in old cart - this is a new item or key changed
      log(`Item at index ${index} is new or key changed: ${newItem.key}`);
      changedIndices.push(index);
      return;
    }

    // Check if quantity changed
    if (oldItem.quantity !== newItem.quantity) {
      log(
        `Item ${index} quantity changed: ${oldItem.quantity} -> ${newItem.quantity}`,
      );
      changedIndices.push(index);
      return;
    }

    // Check if selling plan changed
    const oldPlanId = oldItem.selling_plan_allocation?.selling_plan?.id;
    const newPlanId = newItem.selling_plan_allocation?.selling_plan?.id;
    if (oldPlanId !== newPlanId) {
      log(`Item ${index} selling plan changed: ${oldPlanId} -> ${newPlanId}`);
      changedIndices.push(index);
      return;
    }
  });

  if (changedIndices.length === 0) {
    log("No cart changes detected");
    updatePriceDisplay(cart);
    updateCartDrawerGiftNudge(cart);
    document.dispatchEvent(
      new CustomEvent("cart:updated", { detail: { cart } }),
    );
    return;
  }

  // Update only the changed rows
  log(`Updating ${changedIndices.length} changed rows:`, changedIndices);
  changedIndices.forEach((index) => {
    const row = DOM.cartLinesContainer.querySelector(
      `li[data-index="${index}"]`,
    );
    if (row) {
      log(`Updating row at index ${index}`);
      // Update the key in case it changed
      row.setAttribute("data-key", cart.items[index].key);

      // Render the updated content
      renderSingleRow(cart, index);

      // Reattach listeners to this row
      attachButtonListeners(row);
    } else {
      log(`Warning: Row at index ${index} not found in DOM`);
    }
  });

  updatePriceDisplay(cart);
  updateDiscountsDisplay(cart);
  updateCartDrawerGiftNudge(cart);

  if (cart.items.length > 0) {
    DOM.cartFooter?.classList.add("active");
  }

  document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
}

async function addToCartExternally(
  variantId,
  quantity = 1,
  properties = {},
  sellingPlanId = "",
) {
  log(
    `External add to cart: variant ${variantId}, quantity ${quantity}, selling plan ${sellingPlanId}`,
  );

  const formData = new FormData();
  formData.append("id", variantId);
  formData.append("quantity", quantity);

  // Append properties if any
  Object.entries(properties).forEach(([key, value]) => {
    formData.append(`properties[${key}]`, value);
  });

  // Append selling plan if provided
  if (sellingPlanId) {
    formData.append("selling_plan", sellingPlanId);
  }

  const cartAddFetch = await fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    body: formData,
  });
  // const addedItem = await cartAddFetch.json();
  // log("Item added to cart:", addedItem);
  await openCartAfterAdd({});
}

window.addToCartExternally = addToCartExternally;

window.openCartAfterAdd = openCartAfterAdd;

function getCustomAddToCartForms() {
  return [
    ...new Set(
      Array.from(
        document.querySelectorAll(
          'form[action*="/cart/add"][data-custom-cart-handling], form#pdp-intro-form',
        ),
      ),
    ),
  ];
}

async function handleCustomAddToCartSubmit(event, form) {
  if (form.classList.contains("popup-series-form")) {
    log(
      "Form has popup-series-form class, letting popup series handler take over",
    );
    return;
  }

  event.preventDefault();
  event.stopPropagation();

  log("Add to cart form submitted", form.id || form.className);

  const sellingPlanSelect = form.querySelector('select[name="selling_plan"]');
  const sellingPlanValue = sellingPlanSelect ? sellingPlanSelect.value : "";

  log("Selling plan value from hidden select:", sellingPlanValue);

  const currentCart = await fetchCart();
  updateState(currentCart);

  const formData = new FormData(form);

  const isTBYBPlan =
    sellingPlanValue &&
    CONFIG.tbybSellingPlanIds.some(
      (id) => String(id) === String(sellingPlanValue),
    );

  const isSubscriptionTBYBVariant =
    String(formData.get("id")) === String(CONFIG.tbybVariants.subscription);

  if (isTBYBPlan || isSubscriptionTBYBVariant) {
    log("Attempting to add TBYB item, checking for existing TBYB in cart...");

    const existingTBYB = currentCart.items.some((item) => {
      if (
        String(item.variant_id) === String(CONFIG.tbybVariants.subscription)
      ) {
        return true;
      }

      if (!item.selling_plan_allocation) return false;
      const itemPlanId = String(
        item.selling_plan_allocation.selling_plan.id,
      );
      return CONFIG.tbybSellingPlanIds.some(
        (id) => String(id) === itemPlanId,
      );
    });

    if (existingTBYB) {
      alert(
        "You can only have one Try Before You Buy item in your cart at a time. ",
      );
      return;
    }

    if (isSubscriptionTBYBVariant) {
      const addResponse = await fetch(
        window.Shopify.routes.root + "cart/add.js",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [
              {
                id: Number(CONFIG.tbybVariants.subscription),
                quantity: 1,
                selling_plan: Number(sellingPlanValue),
              },
              {
                id: Number(CONFIG.tbybVariants.subscriptionSwapItem),
                quantity: 1,
                selling_plan: Number(
                  CONFIG.tbybVariants.subscriptionSwapItemPlanId,
                ),
              },
            ],
          }),
        },
      );
      const addedItems = await addResponse.json();
      await openCartAfterAdd(addedItems);
      return;
    }

    formData.set("properties[TBYB]", true);
  }

  if (sellingPlanValue && sellingPlanValue !== "") {
    formData.set("selling_plan", sellingPlanValue);
  }

  const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    body: formData,
  });

  const addedItem = await response.json();

  if (addedItem?.status === 422) {
    log("Add to cart failed:", addedItem);
    alert(addedItem.description || addedItem.message || "Could not add to cart");
    return;
  }

  log("Item added to cart:", addedItem);
  await openCartAfterAdd(addedItem);
}

function bindCustomAddToCartForms() {
  const forms = getCustomAddToCartForms();
  forms.forEach((form) => {
    if (form.dataset.cartDrawerBound === "true") return;
    form.dataset.cartDrawerBound = "true";
    form.addEventListener("submit", (event) =>
      handleCustomAddToCartSubmit(event, form),
    );
    log("Add to cart form listener attached:", form.id || form.className);
  });

  if (!forms.length) {
    log("Warning: No custom add to cart forms found");
  }
}

window.bindCustomAddToCartForms = bindCustomAddToCartForms;

// ============================================
// INITIALIZATION
// ============================================

function init() {
  log("[CartDrawer] ====== INIT CALLED ======");
  log("Initializing cart drawer...");
  log("Config:", CONFIG);
  log("Excluded products:", EXCLUDED_PRODUCTS);
  log("Selling Plan IDs:", CONFIG.sellingPlans);

  // Warn if any selling plans are not configured
  Object.entries(CONFIG.sellingPlans).forEach(([freq, id]) => {
    if (!id) {
      log(`WARNING: Selling plan ID for ${freq} days is not configured!`);
    }
  });

  // Cart drawer controls
  if (DOM.cartOpenButton) {
    DOM.cartOpenButton.addEventListener("click", initializeCartDrawer);
    log("Cart open button listener attached");
  } else {
    log("Warning: Cart open button not found");
  }

  if (DOM.closeCartButton) {
    DOM.closeCartButton.addEventListener("click", closeCartDrawer);
    log("Cart close button listener attached");
  } else {
    log("Warning: Cart close button not found");
  }

  // Close cart when clicking overlay
  const cartOverlay = document.querySelector(".cartOverlay");
  if (cartOverlay) {
    cartOverlay.addEventListener("click", closeCartDrawer);
    log("Cart overlay listener attached");
  }

  // Discount form
  if (DOM.cartDiscountForm) {
    DOM.cartDiscountForm.addEventListener("submit", (e) => {
      e.preventDefault();
      handleAddDiscount();
    });
    log("Discount form listener attached");
  }

  bindCustomAddToCartForms();
  ensureCartLinesDelegation();

  log("Cart drawer initialization complete");
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
